export default {
  en: {
    // Migrated from <i18n> SFC blocks (#6500)
    'cashless-detail': 'Cashless Detail',
    'detail': 'Detail',
    'cashsheet-download': 'Cashsheet Download',
    // CashSheet
    'receipt': 'Receipt',
    'download': 'Download',
    'cashSheet': 'Cash Sheet',
    'otherInfo': 'Other Info',
    'cash-sheet-download': 'Cash Sheet Download',

    // CashSheetOther
    'other-info': 'Other Info',
    'adjusted-figures': 'Adjusted Figures',
    'reconstructed-day': 'Reconstructed Day',
    'pos-removals': 'POS Removals',
    'pos-insertions': 'POS Insertions',
    'rollover': 'Rollover',
    'adjustments': 'Adjustments',
    'weather': 'Weather',
    'comments': 'Comments',
    'store-open': 'Store Open',
    'date-time': 'Date/Time',
    'store-open-user': 'Store Open User',
    'pos-close': 'POS Close',
    'pos-close-user': 'POS Close User',
    'bdc-close': 'BDC Close',
    'bdc-close-user': 'BDC Close User',
    'weather-and-comments': 'Weather and Comments',
    'open-close': 'Open/Close',
    'business-date': 'Business Date',
    'rbd-activation-needed': 'RBD Activation Needed',
    'rbd-activations-needed': 'RBD Activations Needed',
    'rbd-activation-needs-completion': 'RBD activation needs completion',
    'rbd-activations-need-completion': 'RBD activations need completion',

    // RbdActivationDetails
    'rbd-activation-details': 'RBD Activation Details',
    'location': 'Location',
    'date': 'Date',
    'status': 'Status',

    // CashsheetWidget
    'description': 'Description',
    'qty': 'Qty',
    'amt': 'Amt',

    // SalesWidget
    'gross-sales': 'Gross Sales',
    'forever-reading-diff': 'Forever Reading Diff',
    'overrings': 'Overrings',
    'cash-refund-cashout': 'Cash Refund/Cashout',
    'cashless-refund': 'Cashless Refund',
    'gift-card-sold': 'Gift Card Sold',
    'gift-cert-sold': 'Gift Certificate Sold',
    'manual-refund-overrings': 'Manual Refund/Overrings',
    'gma-delivery-driver-tips': 'GMA Delivery Driver Tips',
    'other-receipts': 'Other Receipts',
    'taxes-fees': 'Taxes/Fees',
    'total-tax': 'Total Tax',
    'deposit-1': 'Deposit 1',
    'deposit-2': 'Deposit 2',
    'fee-1': 'Fee 1',
    'fee-2': 'Fee 2',
    'eat-in': 'Eat In',
    'mobile-eat-in-tax': 'Mobile Eat In Tax',
    'take-out': 'Take Out',
    'mobile-takeout-tax': 'Mobile Takeout Tax',
    'delivery-total-tax': 'Delivery Total Tax',
    'door-dash-tax': 'Door Dash Tax',
    'door-dash-1AD-tax': 'Door Dash 1AD Tax',
    'uber-eats-tax': 'Uber Eats Tax',
    'uber-eats-1AD-tax': 'Uber Eats 1AD Tax',
    'grub-hub-tax': 'Grub Hub Tax',
    'grub-hub-1AD-tax': 'Grub Hub 1AD Tax',
    'net-sales': 'Net Sales',
    'product-sales': 'Product Sales',
    'non-product-sales': 'Non-Product Sales',
    'sales': 'Sales',
    'net-sales-is-equal': 'Net sales is equal to gross sales minus discounts, refunds, and taxes.',
    'denotes-a-reconstructed-metric': 'denotes a reconstructed metric',
    'kraven-tax': 'Kraven Tax',
    'kraven-tax-1': 'Kraven Tax 1',
    'kraven-tax-2': 'Kraven Tax 2',
    'kraven-tax-3': 'Kraven Tax 3',
    'kraven-tax-4': 'Kraven Tax 4',
    'monchis-tax': 'Monchis Tax',
    'monchis-tax-1': 'Monchis Tax 1',
    'monchis-tax-2': 'Monchis Tax 2',
    'monchis-tax-3': 'Monchis Tax 3',
    'monchis-tax-4': 'Monchis Tax 4',
    'pedidos-ya-tax': 'PedidosYa Tax',
    'pedidos-ya-tax-1': 'PedidosYa Tax 1',
    'pedidos-ya-tax-2': 'PedidosYa Tax 2',
    'pedidos-ya-tax-3': 'PedidosYa Tax 3',
    'pedidos-ya-tax-4': 'PedidosYa Tax 4',

    // DepositWidget
    'deposit': 'Deposit',
    'cash-over-short-is-equal': 'Cash Over/Short is equal to Expected Deposit minus Expected Cash.',
    'denotes-reconstructed-metric': '# denotes a reconstructed metric',
    'projected-deposit': 'Projected Deposit',
    'foreign-currency-deposit': 'Foreign Currency Deposit',
    'deposit-crime-loss': 'Deposit Crime Loss',
    'petty-cash-reimbursement': 'Petty Cash Reimbursement',
    'actual-deposit': 'Actual Deposit',
    'cash-over-short': 'Cash Over/Short',
    'foreign-currency': 'Foreign Currency',
    'expected-cash': 'Expected Cash',
    'pos-overrings': 'POS Overrings',
    'cash-refund': 'Cash Refund',
    'gift-certificates-redeemed': 'Gift Certificates Redeemed',
    'gift-cards-redeemed': 'Gift Cards Redeemed',
    'mc-balance-redeemed': 'Arch Card Balance Redeemed',
    'billable-sales': 'Billable Sales',
    'delivery-3rd-party-gross': 'Delivery 3rd Party Gross',
    'cashless-sales': 'Cashless Sales',
    'mobile-cashless': 'Mobile Cashless',
    'in-store-cashless': 'In-Store Cashless',
    'prior-day-cash-in-deposit': 'Prior Day Cash In Deposit',
    'cash-for-next-day-deposit': 'Cash for Next Day Deposit',
    'penny-rounding': '(+/-) Penny Order Rounding',

    // AdditionalInfoWidget
    'additional-info': 'Additional Info',
    'average-check': 'Average Check',
    'non-product-sales-amt': 'Non-Product Sales Amt',
    'eat-in-sales': 'Eat-In Sales',
    'take-out-sales': 'Take-Out Sales',
    'drive-thru-sales': 'Drive-Thru Sales',
    'breakfast-sales': 'Breakfast Sales',
    'non-taxable-sales': 'Non-Taxable Sales',
    'tax-exempt-sales': 'Tax Exempt Sales',
    'rmhc': 'RMHC',
    'rmhc-cash': 'RMHC Cash',
    'rmhc-cashless': 'RMHC Cashless',
    'net-sales-digital': 'Net Sales Digital',
    'kiosk': 'Kiosk',
    'eat-in-kiosk': 'Eat In (kiosk)',
    'take-out-kiosk': 'Take Out (kiosk)',
    'mop': 'MOP',
    'eat-in-mop': 'Eat In (MOP)',
    'take-out-mop': 'Take Out (MOP)',
    'delivery': 'Delivery',
    'doordash': 'DoorDash',
    'ubereats': 'UberEats',
    'grubhub': 'GrubHub',
    'discounts': 'Discounts',
    'tred-before': 'TRED Before',
    'tred-after': 'TRED After',
    'discount': 'Discount',
    'electronic-discount': 'Electronic Discount',
    'promo': 'Promo',
    'electronic-promo': 'Electronic Promo',
    'employee-meals': 'Employee Meals',
    'manager-meals': 'Manager Meals',
    'all-coupons': 'All Coupons',
    'coupon': 'Coupon',
    'monchis': 'Monchis',
    'monchisAmt': 'Monchis Amount',
    'monchisQty': 'Monchis Quantity',
    'pedidos-ya': 'PedidosYa',
    'pedidosYaAmt': 'PedidosYa Amount',
    'pedidosYaQty': 'PedidosYa Quantity',

    // Adyen (shared)
    'adyen-essentials': 'Adyen Essentials',
    'no-data-description': 'appearing can be a function of not having the DataPass agreements signed, or not having the reports configured correctly in ADYEN\'s portal.',
    'please-review': 'Please review',
    'adyen-reporting-essentials': 'Adyen Reporting Essentials',
    'for-details': 'for details',
    'adyen-grid-footer': 'If you are not seeing data for location(s), please verify that DataPass approval has been completed and file is in CSV format. Data will be fully updated for dates after the change.',
    'adyen-source-of-truth': 'The Adyen portal is the primary source of truth. To investigate discrepancies reported in the QSRSoft report, the appropriate next step is to verify the data directly against the Adyen portal.',
    'for-more-details': 'For more details visit',
    'adyen-settlement-delay': 'Note: Settlement data is typically 2 days behind. On weekends, this delay could extend to 4-5 days.',
    'file-pending': 'File Pending',
    'settlement-not-received': 'Settlement Not Received',
    'settlement-partially-received': 'Settlement Partially Received',
    'settlement-missing': 'Settlement Missing',
    'record-status': 'Record Status',
    'adyen-variance-summary': 'Adyen Variance Summary',
    'show-flagged': 'Show Flagged',
    'by-gross-variance': 'By Gross Variance',
    'adyen-variance-detail': 'Adyen Variance Detail',
    'adyen-payout-summary': 'Adyen Payout Summary',
    'adyen-Adjustment': 'Adyen Adjustment',
    'adjustment': 'Adjustment',
    'payout-summary': 'Payout Summary',
    'variance-detail': 'Variance Detail',
    'variance-summary': 'Variance Summary',
    'visa': 'Visa',
    'master': 'Master',
    'discover': 'Discover',
    'amex': 'Amex',
    'other': 'Other',
    'debit': 'Debit',
    'batch-number': 'Batch Number',
    'batch-number-description': 'Settlement Batch Number',

    // Deposits
    'deposit-summary-grid-name': 'Deposit Summary',
    'by-store': 'By Store',
    'deposit-code': 'Deposit Code',
    'deposit-code-description': 'Can be standard daypart codes (breakfast, day, night, etc) or custom codes as specified in C&I.',
    'petty-cash-amt': 'Petty Cash Amt',
    'petty-cash-amt-description': 'Dollars of petty cash that were reimbursed from deposits',
    'deposit-amt': 'Deposit Amt',
    'deposit-amt-description': 'Amount of Deposit',
    'deposit-details-grid-name': 'Deposit Details',
    'deposit-details-analysis': 'Deposit Details Analysis',
    'deposit-details-grid-footer': '* Highlighted rows indicate a discrepancy between the "Deposit Amt" and the "Validated Deposit" amount',
    'details': 'Detail',
    'summary': 'Summary',

    // Cashless
    'cashless-summary': 'Cashless Summary',
    'cashless-by-store': 'Cashless By Store',
    'cashless-details': 'Cashless Details',
    'cashless-transactions': 'Cashless Transactions',
    'mobile-cashless-grid-name': 'Mobile Cashless',
    'time': 'Time',
    'time-for-cashless-gc': 'Time for a cashless GC',
    'cashless-origin': 'Cashless Origin',
    'cashless-gc-paid-through-register-or-digital-app': 'Cashless GC paid through register or digital app (In-Store or Mobile)',
    'register-number': 'Register #',
    'which-cash-register-the-cashless-gc-was-finalized-on': 'Which Cash Register the cashless GC was finalized on',
    'type': 'Type',
    'cashless-gc-type': 'Cashless GC Type',
    'card-type': 'Card Type',
    'credit-debit-card-type': 'Credit/Debit Card Type (Visa, Mastercard, Discover, Amex, Debit)',
    'card-number': 'Card #',
    'credit-debit-card-number': 'Credit/Debit Card Number',
    'total-no-gift-card': 'Total No Gift Card',
    'total-with-gift-card': 'Total With Gift Card',
    'pos-diff-no-gift-card': 'POS Diff No Gift Card',
    'arch-card': 'Arch Card',
    'gcard': 'GCard',
    'auth-number': 'Auth #',
    'authorization-number-received-from-credit-card-processor': 'Authorization number received from Credit Card processor',
    'amount': 'Amt',
    'amount-authorized-on-the-credit-card': 'Amount authorized on the credit card',
    'sequence-number': 'Sequence #',
    'this-number-reflects-the-order-of-the-gc-by-register': 'This number reflects the order of the GC by register',
    'linked-payment': 'Linked Payment',
    'whether-the-customer-paid-for': 'Whether the customer paid for an In-Store order with their linked mobile device',
    'Summary': 'Summary',
    'Detail': 'Detail',
    'Mobile': 'Mobile',

    // Tax
    'tax-details-grid-name': 'Tax Details',
    'tax-exempt-grid-name': 'Tax Exempt',
    'tax-exempt-today-grid-name': 'Tax Exempt - Today',
    'company-number': 'Company Number',
    'company-number-description': 'Company Number',
    'cust-name': 'Cust Name',
    'customer-name-description': 'Customer Name',
    'company-name': 'Company Name',
    'company-name-description': 'Company Name',
    'company-address': 'Company Address',
    'company-address-description': 'Company Address',
    'tax-exempt-amt': 'Amt',
    'tax-exempt-amt-description': 'Tax Exempt Amt',
    'payment-type': 'Payment Type',
    'payment-type-description': 'Payment Type',
    'adjusted-description': 'One or more of the figures on the cash sheet was adjusted for the period.',
    'reconstructed-description': 'One or more of the days was reconstructed through the Cash and Inventory application at the restaurant.',
    'register-removed-description': 'A register was removed from the POS system during business hours.',
    'register-added-description': 'A register was added to the POS system during business hours.',
    'rollover-description': 'If a register lasts long enough, eventually the forever reading will "roll over" and start back at 0. If this happens we will display the rollover difference here.',
    'weather-note-description': 'A note on the weather as entered by the restaurant',
    'closing-manager-note-description': 'A note entered by the closing manager to capture any information the manager thinks is important',
    'delivery-tax-total': 'Delivery Tax Total',
    'delivery-tax-total-description': 'Sum of the Tax on Delivery orders across all vendors',
    'delivery-doordash-tax': 'Delivery DoorDash Tax',
    'delivery-doordash-tax-description': 'Total Delivery Tax for DoorDash orders',
    'delivery-doordash-1-ad-tax': 'Delivery DoorDash 1-AD Tax',
    'delivery-doordash-1-ad-tax-description': 'Total Delivery Tax for Integrated DoorDash orders',
    'delivery-doordash-tax-1': 'Delivery DoorDash Tax 1',
    'delivery-doordash-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-1': 'Delivery DoorDash 1-AD Tax 1',
    'delivery-doordash-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-tax-2': 'Delivery DoorDash Tax 2',
    'delivery-doordash-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-2': 'Delivery DoorDash 1-AD Tax 2',
    'delivery-doordash-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-tax-3': 'Delivery DoorDash Tax 3',
    'delivery-doordash-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-3': 'Delivery DoorDash 1-AD Tax 3',
    'delivery-doordash-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-tax-4': 'Delivery DoorDash Tax 4',
    'delivery-doordash-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-4': 'Delivery DoorDash 1-AD Tax 4',
    'delivery-doordash-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax': 'Delivery UberEats Tax',
    'delivery-ubereats-tax-description': 'Total Delivery Tax for UberEats orders',
    'delivery-ubereats-1-ad-tax': 'Delivery UberEats 1-AD Tax',
    'delivery-ubereats-1-ad-tax-description': 'Total Delivery Tax for Integrated UberEats orders',
    'delivery-ubereats-tax-1': 'Delivery UberEats Tax 1',
    'delivery-ubereats-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-1': 'Delivery UberEats 1-AD Tax 1',
    'delivery-ubereats-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax-2': 'Delivery UberEats Tax 2',
    'delivery-ubereats-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-2': 'Delivery UberEats 1-AD Tax 2',
    'delivery-ubereats-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax-3': 'Delivery UberEats Tax 3',
    'delivery-ubereats-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-3': 'Delivery UberEats 1-AD Tax 3',
    'delivery-ubereats-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax-4': 'Delivery UberEats Tax 4',
    'delivery-ubereats-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-4': 'Delivery UberEats 1-AD Tax 4',
    'delivery-ubereats-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax': 'Delivery GrubHub Tax',
    'delivery-grubhub-tax-description': 'Total Delivery Tax for GrubHub orders',
    'delivery-grubhub-1-ad-tax': 'Delivery GrubHub 1-AD Tax',
    'delivery-grubhub-1-ad-tax-description': 'Total Delivery Tax for Integrated GrubHub orders',
    'delivery-grubhub-tax-1': 'Delivery GrubHub Tax 1',
    'delivery-grubhub-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-1': 'Delivery GrubHub 1-AD Tax 1',
    'delivery-grubhub-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax-2': 'Delivery GrubHub Tax 2',
    'delivery-grubhub-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-2': 'Delivery GrubHub 1-AD Tax 2',
    'delivery-grubhub-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax-3': 'Delivery GrubHub Tax 3',
    'delivery-grubhub-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-3': 'Delivery GrubHub 1-AD Tax 3',
    'delivery-grubhub-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax-4': 'Delivery GrubHub Tax 4',
    'delivery-grubhub-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-4': 'Delivery GrubHub 1-AD Tax 4',
    'delivery-grubhub-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax': 'Delivery PostMates Tax',
    'delivery-postmates-tax-description': 'Total Delivery Tax for PostMates orders',
    'delivery-postmates-1-ad-tax': 'Delivery PostMates 1-AD Tax',
    'delivery-postmates-1-ad-tax-description': 'Total Delivery Tax for Integrated PostMates orders',
    'delivery-postmates-tax-1': 'Delivery PostMates Tax 1',
    'delivery-postmates-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-1': 'Delivery PostMates 1-AD Tax 1',
    'delivery-postmates-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax-2': 'Delivery PostMates Tax 2',
    'delivery-postmates-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-2': 'Delivery PostMates 1-AD Tax 2',
    'delivery-postmates-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax-3': 'Delivery PostMates Tax 3',
    'delivery-postmates-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-3': 'Delivery PostMates 1-AD Tax 3',
    'delivery-postmates-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax-4': 'Delivery PostMates Tax 4',
    'delivery-postmates-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-4': 'Delivery PostMates 1-AD Tax 4',
    'delivery-postmates-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-1': 'Mobile Eat In Tax 1',
    'mobile-eat-in-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-2': 'Mobile Eat In Tax 2',
    'mobile-eat-in-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-3': 'Mobile Eat In Tax 3',
    'mobile-eat-in-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-4': 'Mobile Eat In Tax 4',
    'mobile-eat-in-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-total': 'Mobile Eat In Tax Total',
    'mobile-eat-in-tax-total-description': 'Tax on Mobile orders that are consumed at the restaurant',
    'mobile-takeout-tax-1': 'Mobile Takeout Tax 1',
    'mobile-takeout-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-2': 'Mobile Takeout Tax 2',
    'mobile-takeout-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-3': 'Mobile Takeout Tax 3',
    'mobile-takeout-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-4': 'Mobile Takeout Tax 4',
    'mobile-takeout-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-total': 'Mobile Takeout Tax Total',
    'mobile-takeout-tax-total-description': 'Tax on Mobile orders that are taken from the restaurant for consumption',
    'eat-in-tax-amt': 'Eat In Tax Amt',
    'eat-in-tax-amt-description': 'Total Tax for orders that are consumed at the restaurant',
    'eat-in-tax-1': 'Eat In Tax 1',
    'eat-in-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'eat-in-tax-2': 'Eat In Tax 2',
    'eat-in-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'eat-in-tax-3': 'Eat In Tax 3',
    'eat-in-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'eat-in-tax-4': 'Eat In Tax 4',
    'eat-in-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-amt': 'TakeOut Tax Amt',
    'takeout-tax-amt-description': 'Total Tax for orders that are taken from the restaurant for consumption',
    'takeout-tax-1': 'TakeOut Tax 1',
    'takeout-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-2': 'TakeOut Tax 2',
    'takeout-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-3': 'TakeOut Tax 3',
    'takeout-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-4': 'TakeOut Tax 4',
    'takeout-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'fee-1-amount': 'Fee 1 Amount',
    'fee-1-amount-description': 'The POS allows for collection of Fees (separate from taxes and usually not taxed)',
    'fee-2-amount': 'Fee 2 Amount',
    'fee-2-amount-description': 'The POS allows for collection of Fees (separate from taxes and usually not taxed)',
    'deposit-1-amount': 'Deposit 1 Amount',
    'deposit-1-amount-description': 'Amount of any Deposit 1 charged to the customer for bottles',
    'deposit-2-amount': 'Deposit 2 Amount',
    'deposit-2-amount-description': 'Amount of any Deposit 2 charged to the customer for bottles',
    'deposit-amt-bottles-description': 'Total amount of any deposits charged to the customer for bottles',

    // Register Audit
    'register-audit': 'Register Audit',
    'this-report-aggregates-footnote': 'This report aggregates values based on drawers. In 24-hour restaurants, drawers can cross the End of Business Day and the values may not match back to the values on the cash sheet',
    'by-location': 'By Location',
    'sum-all-locations': 'Sum All Locations',
    'by-employee': 'By Employee',
    'employee-drawer': 'Employee Drawer',
    'cashier': 'Cashier',
    'cashier-name': 'Cashier Name',
    'manager': 'Manager',
    'manager-name': 'Manager Name',
    'preparer': 'Preparer',
    'preparer-name': 'Preparer Name',
    'cash-out-time': 'Cash Out Time',
    'time-the-cash-register-drawer-was-closed': 'Time the cash register drawer was closed',
    'emp-name': 'Emp Name',
    'employee-name': 'Employee Name',
    'Register': 'Register',
    'By-Location': 'By Location',
    'By-Employee': 'By Employee',
    'Employee': 'Employee',

    // Gift Card Summary
    'gift-card-summary': 'Gift Card Summary',
    'net-qty': 'Net Qty',
    'sold-qty-redeemed-qty': 'Sold Qty - Redeemed Qty',
    'net-amt': 'Net Amt',
    'sold-dollars-redeemed-dollars': 'Sold Dollars - Redeemed Dollars',
    'sold-qty': 'Sold Qty',
    'the-quantity-of-gift-cards-activated-or-reloaded': 'The quantity of gift cards activated or reloaded',
    'sold-dollars': 'Sold Dollars',
    'the-dollar-amount-of-gift-cards-activated-or-reloaded': 'The dollar amount of gift cards activated or reloaded',
    'sold-average-check': 'Sold Average Check',
    'sold-dollars-sold-qty': 'Sold Dollars / Sold Qty',
    'redeemed-qty': 'Redeemed Qty',
    'the-quantity-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'The quantity of gift cards used to pay all or part of an order',
    'redeemed-dollars': 'Redeemed Dollars',
    'the-dollar-amount-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'The dollar amount of gift cards used to pay all or part of an order',
    'redeemed-average-check': 'Redeemed Average Check',
    'redeemed-dollars-redeemed-qty': 'Redeemed Dollars / Redeemed Qty',
    'gift-card-summary-catalog-grid-name': 'Gift Card Summary',

    // Other Receipts
    'other-receipts-grid-name': 'Other Receipts',
    'other-receipts-grid-footer': 'If the date range includes a date with an RBD, this report might not match the Cash Sheet.',
    'other-receipts-today-grid-name': 'Other Receipts - Today',
    'other-receipts-detail-grid-name': 'Other Receipts Details',

    // Billable Sales / Safe Counts
    'billable-sales-grid-name': 'Billable Sales',
    'safe-counts-grid-name': 'Safe Counts',

    // ByMenuItemSelector
    'by-menu-item': 'By Menu Item',

    // Cash Statistics (standard)
    'cash-statistics': 'Cash Statistics',
    'by-date': 'By Date',
    'cash-statistics-analysis': 'Cash Statistics Analysis',

    // Legacy camelCase keys (kept for backward compatibility with existing code)
    'drawer': 'Drawer',
    'safeCount': 'Safe Count',
    'cashOverShort': 'Cash Over/Short',
    'cashOverShortDescription': 'Cash Over/Short is equal to Expected Deposit minus Expected Cash.',
    'projectedDeposit': 'Projected Deposit',
    'foreignCurrencyDeposit': 'Foreign Currency Deposit',
    'depositCrimeLoss': 'Deposit Crime Loss',
    'pettyCashReimbursement': 'Petty Cash Reimbursement',
    'actualDeposit': 'Actual Deposit',
    'foreignCurrency': 'Foreign Currency',
    'expectedCash': 'Expected Cash',
    'posOverrings': 'POS Overrings',
    'cashRefund': 'Cash Refund',
    'giftCertificatesRedeemed': 'Gift Certificates Redeemed',
    'giftCardsRedeemed': 'Gift Cards Redeemed',
    'billableSales': 'Billable Sales',
    'delivery3rdPartyGross': 'Delivery 3rd Party Gross',
    'cashlessSales': 'Cashless Sales',
    'mobileCashless': 'Mobile Cashless',
    'inStoreCashless': 'In-Store Cashless',
    'denotesReconstructedMetric': '# denotes a reconstructed metric',

    // CashsheetReceipt (MT redesign)
    'cs-breakdown': 'Breakdown',
    'cs-net-sales-by-channel': 'Net Sales by Channel',
    'cs-taxable-sales': 'Taxable Sales',
    'cs-delivery-3rd-party': '3rd Party',
    'cs-delivery-internal': 'Internal',
    'cs-transactions': 'Transactions',
    'cs-pct-of-gross': '{pct} of gross',
    'cs-pct-of-net': '{pct} of net',
    'cs-avg-check': 'Avg check {amt}',
    'cs-drawer-reconciliation': 'Drawer reconciliation',
    'cs-where-the-net-came-from': 'Where the net came from',
    'cs-error-loading': 'Something went wrong loading the cash sheet.',
    'cs-hide-zero-rows': 'Hide zero rows',
    'cs-vs-ly': 'vs LY {pct}',
    'cs-deposit-short': 'Deposit short',
    'cs-deposit-over': 'Deposit over',
    'cs-total-surcharges': 'Total Surcharges',
  },
  es: {
    // Migrated from <i18n> SFC blocks (#6500)
    'cashless-detail': 'Detalle Sin Efectivo',
    'detail': 'Detalle',
    'cashsheet-download': 'Descarga de Cashsheet',
    // CashSheet
    'receipt': 'Recibo',
    'download': 'Descargar',
    'cashSheet': 'Hoja de Efectivo',
    'otherInfo': 'Otra Información',
    'cash-sheet-download': 'Descarga de Hoja de Caja',

    // CashSheetOther
    'other-info': 'Otra Información',
    'adjusted-figures': 'Figuras Ajustadas',
    'reconstructed-day': 'Día Reconstruido',
    'pos-removals': 'Remociones de Punto de Venta',
    'pos-insertions': 'Inserciones de Punto de Venta',
    'rollover': 'Traspaso',
    'adjustments': 'Ajustes',
    'weather': 'Clima',
    'comments': 'Comentarios',
    'store-open': 'Tienda Abierta',
    'date-time': 'Fecha/Hora',
    'store-open-user': 'Usuario de Tienda Abierta',
    'pos-close': 'Cierre de Punto de Venta',
    'pos-close-user': 'Usuario de Cierre de Punto de Venta',
    'bdc-close': 'Cierre de BDC',
    'bdc-close-user': 'Usuario de Cierre de BDC',
    'weather-and-comments': 'Clima y Comentarios',
    'open-close': 'Abierto/Cerrado',
    'business-date': 'Fecha de Negocio',
    'rbd-activation-needed': 'Activación RBD Necesaria',
    'rbd-activations-needed': 'Activaciones RBD Necesarias',
    'rbd-activation-needs-completion': 'activación RBD necesita completarse',
    'rbd-activations-need-completion': 'activaciones RBD necesitan completarse',

    // RbdActivationDetails
    'rbd-activation-details': 'Detalles de Activación RBD',
    'location': 'Ubicación',
    'date': 'Fecha',
    'status': 'Estado',

    // CashsheetWidget
    'description': 'Descripción',
    'qty': 'Cantidad',
    'amt': 'Monto',

    // SalesWidget
    'gross-sales': 'Ventas Brutas',
    'forever-reading-diff': 'Diferencia de Lectura Eterna',
    'overrings': 'Anulaciones',
    'cash-refund-cashout': 'Reembolso/Retiro de Efectivo',
    'cashless-refund': 'Reembolso sin Efectivo',
    'gift-card-sold': 'Tarjeta de Regalo Vendidas',
    'gift-cert-sold': 'Certificados de Regalo Vendidos',
    'manual-refund-overrings': 'Reembolso Manual/Anulaciones',
    'gma-delivery-driver-tips': 'Consejos para Conductores de Reparto de GMA',
    'other-receipts': 'Otros Recibos',
    'taxes-fees': 'Impuestos/Tarifas',
    'total-tax': 'Impuestos Total',
    'deposit-1': 'Deposito 1',
    'deposit-2': 'Deposito 2',
    'fee-1': 'Tarifa 1',
    'fee-2': 'Tarifa 2',
    'eat-in': 'Consumir Aquí',
    'mobile-eat-in-tax': 'Impuestos para Consumir Aquí Usando Movil',
    'take-out': 'Para Llevar',
    'mobile-takeout-tax': 'Impuesto Sobre Comida para Llevar a Través del Móvil',
    'delivery-total-tax': 'Entrega Impuestos Totales',
    'door-dash-tax': 'Impuestos de Door Dash',
    'door-dash-1AD-tax': 'Impuestos 1AD Door Dash',
    'uber-eats-tax': 'Impuestos de Uber Eats',
    'uber-eats-1AD-tax': 'Impuestos 1AD Uber Eats',
    'grub-hub-tax': 'Impuestos de Grubhub',
    'grub-hub-1AD-tax': 'Impuestos 1AD Grub Hub',
    'net-sales': 'Ventas Netas',
    'product-sales': 'Ventas de Productos',
    'non-product-sales': 'Ventas de Productos no Relacionados',
    'sales': 'Ventas',
    'net-sales-is-equal': 'Las ventas netas son iguales a las ventas brutas menos descuentos, reembolsos e impuestos.',
    'denotes-a-reconstructed-metric': 'denota una métrica reconstruida',
    'kraven-tax': 'Impuesto Kraven',
    'kraven-tax-1': 'Impuesto Kraven 1',
    'kraven-tax-2': 'Impuesto Kraven 2',
    'kraven-tax-3': 'Impuesto Kraven 3',
    'kraven-tax-4': 'Impuesto Kraven 4',
    'monchis-tax': 'Impuesto Monchis',
    'monchis-tax-1': 'Impuesto Monchis 1',
    'monchis-tax-2': 'Impuesto Monchis 2',
    'monchis-tax-3': 'Impuesto Monchis 3',
    'monchis-tax-4': 'Impuesto Monchis 4',
    'pedidos-ya-tax': 'Impuesto PedidosYa',
    'pedidos-ya-tax-1': 'Impuesto PedidosYa 1',
    'pedidos-ya-tax-2': 'Impuesto PedidosYa 2',
    'pedidos-ya-tax-3': 'Impuesto PedidosYa 3',
    'pedidos-ya-tax-4': 'Impuesto PedidosYa 4',

    // DepositWidget
    'deposit': 'Depósito',
    'cash-over-short-is-equal': 'Efectivo Sobrante/Faltante es igual a Depósito Esperado menos Efectivo Esperado.',
    'denotes-reconstructed-metric': '# denota una métrica reconstruida',
    'projected-deposit': 'Depósito Proyectado',
    'foreign-currency-deposit': 'Depósito de Moneda Extranjera',
    'deposit-crime-loss': 'Pérdida de Crimen de Depósito',
    'petty-cash-reimbursement': 'Reembolso de Caja Chica',
    'actual-deposit': 'Depósito Real',
    'cash-over-short': 'Efectivo Sobrante/Faltante',
    'foreign-currency': 'Moneda Extranjera',
    'expected-cash': 'Efectivo Esperado',
    'pos-overrings': 'Sobregiros POS',
    'cash-refund': 'Reembolso de Efectivo',
    'gift-certificates-redeemed': 'Certificados de Regalo Canjeados',
    'gift-cards-redeemed': 'Tarjetas de Regalo Canjeadas',
    'mc-balance-redeemed': 'Saldo de Arch Card Canjeado',
    'billable-sales': 'Ventas Facturables',
    'delivery-3rd-party-gross': 'Entrega 3ra Parte Bruto',
    'cashless-sales': 'Ventas Sin Efectivo',
    'mobile-cashless': 'Sin Efectivo Móvil',
    'in-store-cashless': 'Sin Efectivo en la Tienda',
    'prior-day-cash-in-deposit': 'Depósito de Efectivo del Día Anterior',
    'cash-for-next-day-deposit': 'Efectivo para el Depósito del Día Siguiente',
    'penny-rounding': '(+/-) Redondeo de Centavos',

    // AdditionalInfoWidget
    'additional-info': 'Información Adicional',
    'average-check': 'Cheque Promedio',
    'non-product-sales-amt': 'Monto de Ventas no Relacionadas con Productos',
    'eat-in-sales': 'Ventas Para Comer en el Local',
    'take-out-sales': 'Ventas Para Llevar',
    'drive-thru-sales': 'Ventas en el Auto',
    'breakfast-sales': 'Ventas de Desayuno',
    'non-taxable-sales': 'Ventas no Gravables',
    'tax-exempt-sales': 'Ventas Exentas de Impuestos',
    'rmhc': 'Organización Benéfica de la Casa Ronald McDonald',
    'rmhc-cash': 'Organización Benéfica de la Casa Ronald McDonald en Efectivo',
    'rmhc-cashless': 'Organización Benéfica de la Casa Ronald McDonald sin Efectivo',
    'net-sales-digital': 'Ventas Netas Digitales',
    'kiosk': 'Kiosco',
    'eat-in-kiosk': 'Comer en el Kiosco',
    'take-out-kiosk': 'Llevar en el Kiosco',
    'mop': 'MOP',
    'eat-in-mop': 'Comer en MOP',
    'take-out-mop': 'Llevar en MOP',
    'delivery': 'Entrega',
    'doordash': 'DoorDash',
    'ubereats': 'UberEats',
    'grubhub': 'GrubHub',
    'discounts': 'Descuentos',
    'tred-before': 'TRED Antes',
    'tred-after': 'TRED Después',
    'discount': 'Descuento',
    'electronic-discount': 'Descuento Electrónico',
    'promo': 'Promoción',
    'electronic-promo': 'Promoción Electrónica',
    'employee-meals': 'Comidas de Empleados',
    'manager-meals': 'Comidas de Gerentes',
    'all-coupons': 'Todos los Cupones',
    'coupon': 'Cupón',
    'monchis': 'Monchis',
    'monchisAmt': 'Monto Monchis',
    'monchisQty': 'Cantidad Monchis',
    'pedidos-ya': 'PedidosYa',
    'pedidosYaAmt': 'Monto PedidosYa',
    'pedidosYaQty': 'Cantidad PedidosYa',

    // Adyen (shared)
    'adyen-essentials': 'Adyen Esenciales',
    'no-data-description': 'aparecer puede ser una función de no tener los acuerdos de DataPass firmados, o no tener los informes configurados correctamente en el portal de ADYEN.',
    'please-review': 'Por favor, revise',
    'adyen-reporting-essentials': 'Elementos Esenciales de Informes de Adyen',
    'for-details': 'para detalles',
    'adyen-grid-footer': 'Si no está viendo datos para las ubicaciones, por favor verifique que la aprobación de DataPass se haya completado y que el archivo esté en formato CSV. Los datos se actualizarán completamente para las fechas posteriores al cambio.',
    'adyen-source-of-truth': 'El portal de Adyen es la fuente principal de verdad. Para investigar discrepancias reportadas en el informe de QSRSoft, el siguiente paso apropiado es verificar los datos directamente contra el portal de Adyen.',
    'for-more-details': 'Para más detalles visite',
    'adyen-settlement-delay': 'Nota: Los datos de liquidación generalmente tienen un retraso de 2 días. Los fines de semana, este retraso podría extenderse a 4-5 días.',
    'file-pending': 'Archivo Pendiente',
    'settlement-not-received': 'Liquidación No Recibida',
    'settlement-partially-received': 'Liquidación Parcialmente Recibida',
    'settlement-missing': 'Liquidación Faltante',
    'record-status': 'Estado del Registro',
    'adyen-variance-summary': 'Resumen de Variación de Adyen',
    'show-flagged': 'Mostrar Marcados',
    'by-gross-variance': 'Por Variación Bruta',
    'adyen-variance-detail': 'Detalle de Variación de Adyen',
    'adyen-payout-summary': 'Resumen de Pagos de Adyen',
    'adyen-Adjustment': 'Ajuste de Adyen',
    'adjustment': 'Ajuste',
    'payout-summary': 'Resumen de Pagos',
    'variance-detail': 'Detalle de Varianza',
    'variance-summary': 'Resumen de Varianza',
    'visa': 'Visa',
    'master': 'Master',
    'discover': 'Discover',
    'amex': 'Amex',
    'other': 'Otro',
    'debit': 'Débito',
    'batch-number': 'Número de Lote',
    'batch-number-description': 'Número de Lote de Liquidación',

    // Deposits
    'deposit-summary-grid-name': 'Resumen de Depósitos',
    'by-store': 'Por Ubicación',
    'deposit-code': 'Código de Depósito',
    'deposit-code-description': 'Puede ser códigos estándar de parte del día (desayuno, día, noche, etc.) o códigos personalizados según lo especificado en C&I.',
    'petty-cash-amt': 'Monto de Efectivo Menor',
    'petty-cash-amt-description': 'Dólares de efectivo menor que fueron reembolsados de los depósitos',
    'deposit-amt': 'Monto del Depósito',
    'deposit-amt-description': 'Monto del Depósito',
    'deposit-details-grid-name': 'Detalles del Depósito',
    'deposit-details-analysis': 'Análisis de Detalles del Depósito',
    'deposit-details-grid-footer': '* Las filas resaltadas indican una discrepancia entre el "Monto del Depósito" y el "Depósito Validado"',
    'details': 'Detalle',
    'summary': 'Resumen',

    // Cashless
    'cashless-summary': 'Resumen sin Efectivo',
    'cashless-by-store': 'Sin Efectivo por Tienda',
    'cashless-details': 'Detalles sin Efectivo',
    'cashless-transactions': 'Transacciones sin Efectivo',
    'mobile-cashless-grid-name': 'Sin Efectivo Móvil',
    'time': 'Hora',
    'time-for-cashless-gc': 'Hora para una GC sin efectivo',
    'cashless-origin': 'Origen sin Efectivo',
    'cashless-gc-paid-through-register-or-digital-app': 'GC sin efectivo pagado a través de la aplicación de registro o digital (en la tienda o móvil)',
    'register-number': 'Número de Registro',
    'which-cash-register-the-cashless-gc-was-finalized-on': 'En qué caja registradora se finalizó la GC sin efectivo',
    'type': 'Tipo',
    'cashless-gc-type': 'Tipo de GC sin Efectivo',
    'card-type': 'Tipo de Tarjeta',
    'credit-debit-card-number': 'Número de Tarjeta de Crédito/Débito',
    'total-no-gift-card': 'Total Sin Tarjeta de Regalo',
    'total-with-gift-card': 'Total Con Tarjeta de Regalo',
    'pos-diff-no-gift-card': 'Dif. POS Sin Tarjeta de Regalo',
    'arch-card': 'Arch Card',
    'gcard': 'Tarjeta de Regalo',
    'credit-debit-card-type': 'Tipo de tarjeta de crédito/débito (Visa, Mastercard, Discover, Amex, Débito)',
    'card-number': 'Número de Tarjeta',
    'auth-number': 'Número de Autorización',
    'authorization-number-received-from-credit-card-processor': 'Número de autorización recibido del procesador de tarjetas de crédito',
    'amount': 'Monto',
    'amount-authorized-on-the-credit-card': 'Monto autorizado en la tarjeta de crédito',
    'sequence-number': 'Número de Secuencia',
    'this-number-reflects-the-order-of-the-gc-by-register': 'Este número refleja el orden de la GC por registro',
    'linked-payment': 'Pago Vinculado',
    'whether-the-customer-paid-for': 'Si el cliente pagó un pedido en la tienda con su dispositivo móvil vinculado',
    'Summary': 'Resumen',
    'Detail': 'Detalle',
    'Mobile': 'Móvil',

    // Tax
    'tax-details-grid-name': 'Detalles de Impuestos',
    'tax-exempt-grid-name': 'Exento de Impuestos',
    'tax-exempt-today-grid-name': 'Exento de Impuestos - Hoy',
    'company-number': 'Número de Empresa',
    'company-number-description': 'Número de Empresa',
    'cust-name': 'Nombre del Cliente',
    'customer-name-description': 'Nombre del Cliente',
    'company-name': 'Nombre de la Empresa',
    'company-name-description': 'Nombre de la Empresa',
    'company-address': 'Dirección de la Empresa',
    'company-address-description': 'Dirección de la Empresa',
    'tax-exempt-amt': 'Monto',
    'tax-exempt-amt-description': 'Monto Exento de Impuestos',
    'payment-type': 'Tipo de Pago',
    'payment-type-description': 'Tipo de Pago',
    'adjusted-description': 'Una o más cifras de la hoja de caja fueron ajustadas para el período.',
    'reconstructed-description': 'Uno o más días fueron reconstruidos mediante la aplicación de Caja e Inventario en el restaurante.',
    'register-removed-description': 'Se eliminó una caja registradora del sistema POS durante el horario comercial.',
    'register-added-description': 'Se agregó una caja registradora al sistema POS durante el horario comercial.',
    'rollover-description': 'Si una caja registradora dura suficiente tiempo, eventualmente la lectura permanente se "reiniciará" y comenzará de nuevo en 0. Si esto ocurre, mostraremos la diferencia del reinicio aquí.',
    'weather-note-description': 'Una nota sobre el clima ingresada por el restaurante',
    'closing-manager-note-description': 'Una nota ingresada por el gerente de cierre para capturar cualquier información que el gerente considere importante',
    'delivery-tax-total': 'Total de Impuesto de Entrega',
    'delivery-tax-total-description': 'Suma del Impuesto en pedidos de Entrega a través de todos los proveedores',
    'delivery-doordash-tax': 'Total de Impuesto de Entrega de DoorDash',
    'delivery-doordash-tax-description': 'Suma del Impuesto en pedidos de Entrega de DoorDash',
    'delivery-doordash-1-ad-tax': 'Total de Impuesto de Entrega de DoorDash 1-AD',
    'delivery-doordash-1-ad-tax-description': 'Suma del Impuesto en pedidos de Entrega de DoorDash 1-AD',
    'delivery-doordash-tax-1': 'Impuesto de Entrega de DoorDash 1',
    'delivery-doordash-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-1': 'Impuesto de Entrega de DoorDash 1-AD',
    'delivery-doordash-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-tax-2': 'Impuesto de Entrega de DoorDash 2',
    'delivery-doordash-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-2': 'Impuesto de Entrega de DoorDash 1-AD 2',
    'delivery-doordash-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-tax-3': 'Impuesto de Entrega de DoorDash 3',
    'delivery-doordash-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-3': 'Impuesto de Entrega de DoorDash 1-AD 3',
    'delivery-doordash-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-tax-4': 'Impuesto de Entrega de DoorDash 4',
    'delivery-doordash-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-4': 'Impuesto de Entrega de DoorDash 1-AD 4',
    'delivery-doordash-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax': 'Impuesto de Entrega de UberEats',
    'delivery-ubereats-tax-description': 'La cantidad total de Impuesto de Entrega para pedidos de UberEats',
    'delivery-ubereats-1-ad-tax': 'Impuesto de Entrega de UberEats 1-AD',
    'delivery-ubereats-1-ad-tax-description': 'La cantidad total de Impuesto de Entrega para pedidos de UberEats 1-AD',
    'delivery-ubereats-tax-1': 'Impuesto de Entrega de UberEats 1',
    'delivery-ubereats-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-1': 'Impuesto de Entrega de UberEats 1-AD',
    'delivery-ubereats-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax-2': 'Impuesto de Entrega de UberEats 2',
    'delivery-ubereats-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-2': 'Impuesto de Entrega de UberEats 1-AD 2',
    'delivery-ubereats-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax-3': 'Impuesto de Entrega de UberEats 3',
    'delivery-ubereats-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-3': 'Impuesto de Entrega de UberEats 1-AD 3',
    'delivery-ubereats-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax-4': 'Impuesto de Entrega de UberEats 4',
    'delivery-ubereats-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-4': 'Impuesto de Entrega de UberEats 1-AD 4',
    'delivery-ubereats-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax': 'Impuesto de Entrega de GrubHub',
    'delivery-grubhub-tax-description': 'Impuesto total de Entrega para pedidos de GrubHub',
    'delivery-grubhub-1-ad-tax': 'Impuesto de Entrega de GrubHub 1-AD',
    'delivery-grubhub-1-ad-tax-description': 'Impuesto total de Entrega para pedidos integrados de GrubHub',
    'delivery-grubhub-tax-1': 'Impuesto de Entrega de GrubHub 1',
    'delivery-grubhub-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-1': 'Impuesto de Entrega de GrubHub 1-AD 1',
    'delivery-grubhub-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax-2': 'Impuesto de Entrega de GrubHub 2',
    'delivery-grubhub-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-2': 'Impuesto de Entrega de GrubHub 1-AD 2',
    'delivery-grubhub-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax-3': 'Impuesto de Entrega de GrubHub 3',
    'delivery-grubhub-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-3': 'Impuesto de Entrega de GrubHub 1-AD 3',
    'delivery-grubhub-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax-4': 'Impuesto de Entrega de GrubHub 4',
    'delivery-grubhub-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-4': 'Impuesto de Entrega de GrubHub 1-AD 4',
    'delivery-grubhub-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax': 'Impuesto de Entrega de PostMates',
    'delivery-postmates-tax-description': 'Impuesto total de Entrega para pedidos de PostMates',
    'delivery-postmates-1-ad-tax': 'Impuesto de Entrega de PostMates 1-AD',
    'delivery-postmates-1-ad-tax-description': 'Impuesto total de Entrega para pedidos integrados de PostMates',
    'delivery-postmates-tax-1': 'Impuesto de Entrega de PostMates 1',
    'delivery-postmates-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-1': 'Impuesto de Entrega de PostMates 1-AD 1',
    'delivery-postmates-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax-2': 'Impuesto de Entrega de PostMates 2',
    'delivery-postmates-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-2': 'Impuesto de Entrega de PostMates 1-AD 2',
    'delivery-postmates-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax-3': 'Impuesto de Entrega de PostMates 3',
    'delivery-postmates-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-3': 'Impuesto de Entrega de PostMates 1-AD 3',
    'delivery-postmates-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax-4': 'Impuesto de Entrega de PostMates 4',
    'delivery-postmates-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-4': 'Impuesto de Entrega de PostMates 1-AD 4',
    'delivery-postmates-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-1': 'Impuesto Móvil para Comer Aquí 1',
    'mobile-eat-in-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-2': 'Impuesto Móvil para Comer Aquí 2',
    'mobile-eat-in-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-3': 'Impuesto Móvil para Comer Aquí 3',
    'mobile-eat-in-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-4': 'Impuesto Móvil para Comer Aquí 4',
    'mobile-eat-in-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-total': 'Total de Impuesto Móvil para Comer Aquí',
    'mobile-eat-in-tax-total-description': 'Impuesto sobre pedidos móviles que se consumen en el restaurante',
    'mobile-takeout-tax-1': 'Impuesto Móvil para Llevar 1',
    'mobile-takeout-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-2': 'Impuesto Móvil para Llevar 2',
    'mobile-takeout-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-3': 'Impuesto Móvil para Llevar 3',
    'mobile-takeout-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-4': 'Impuesto Móvil para Llevar 4',
    'mobile-takeout-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-total': 'Total de Impuesto Móvil para Llevar',
    'mobile-takeout-tax-total-description': 'Impuesto sobre pedidos móviles que se toman del restaurante para consumo',
    'eat-in-tax-amt': 'Monto de Impuesto para Comer Aquí',
    'eat-in-tax-amt-description': 'Impuesto total para pedidos que se consumen en el restaurante',
    'eat-in-tax-1': 'Impuesto para Comer Aquí 1',
    'eat-in-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'eat-in-tax-2': 'Impuesto para Comer Aquí 2',
    'eat-in-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'eat-in-tax-3': 'Impuesto para Comer Aquí 3',
    'eat-in-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'eat-in-tax-4': 'Impuesto para Comer Aquí 4',
    'eat-in-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-amt': 'Monto de Impuesto para Llevar',
    'takeout-tax-amt-description': 'Impuesto total para pedidos que se toman del restaurante para consumo',
    'takeout-tax-1': 'Impuesto para Llevar 1',
    'takeout-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-2': 'Impuesto para Llevar 2',
    'takeout-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-3': 'Impuesto para Llevar 3',
    'takeout-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-4': 'Impuesto para Llevar 4',
    'takeout-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'fee-1-amount': 'Monto de Tarifa 1',
    'fee-1-amount-description': 'El POS permite la recolección de Tarifas (separadas de impuestos y usualmente no gravadas)',
    'fee-2-amount': 'Monto de Tarifa 2',
    'fee-2-amount-description': 'El POS permite la recolección de Tarifas (separadas de impuestos y usualmente no gravadas)',
    'deposit-1-amount': 'Monto de Depósito 1',
    'deposit-1-amount-description': 'Monto de cualquier Depósito 1 cobrado al cliente por botellas',
    'deposit-2-amount': 'Monto de Depósito 2',
    'deposit-2-amount-description': 'Monto de cualquier Depósito 2 cobrado al cliente por botellas',
    'deposit-amt-bottles-description': 'Monto total de cualquier depósito cobrado al cliente por botellas',

    // Register Audit
    'register-audit': 'Auditoría de Caja',
    'this-report-aggregates-footnote': 'Este informe agrega valores en función de las cajas registradoras. En los restaurantes de 24 horas, las cajas pueden cruzar el Fin del Día Comercial y los valores pueden no coincidir con los valores de la hoja de caja',
    'by-location': 'Por Ubicación',
    'sum-all-locations': 'Suma Todas las Ubicaciones',
    'by-employee': 'Por Empleado',
    'employee-drawer': 'Cajón de Empleado',
    'cashier': 'Cajero',
    'cashier-name': 'Nombre del Cajero',
    'manager': 'Gerente',
    'manager-name': 'Nombre del Gerente',
    'preparer': 'Preparador',
    'preparer-name': 'Nombre del Preparador',
    'cash-out-time': 'Hora de Cierre',
    'time-the-cash-register-drawer-was-closed': 'Hora en que se cerró el cajón de la caja',
    'emp-name': 'Nombre del Empleado',
    'employee-name': 'Nombre del Empleado',
    'Register': 'Registro',
    'By-Location': 'Por Ubicación',
    'By-Employee': 'Por Empleado',
    'Employee': 'Empleado',

    // Gift Card Summary
    'gift-card-summary': 'Resumen de Tarjetas de Regalo',
    'net-qty': 'Cantidad Neta',
    'sold-qty-redeemed-qty': 'Cantidad vendida - Cantidad Canjeada',
    'net-amt': 'Monto Neto',
    'sold-dollars-redeemed-dollars': 'Dólares vendidos - Dólares Canjeados',
    'sold-qty': 'Cantidad Vendida',
    'the-quantity-of-gift-cards-activated-or-reloaded': 'La cantidad de tarjetas de regalo activadas o recargadas',
    'sold-dollars': 'Dólares Vendidos',
    'the-dollar-amount-of-gift-cards-activated-or-reloaded': 'La cantidad de dólares de tarjetas de regalo activadas o recargadas',
    'sold-average-check': 'Promedio de Cheque Vendido',
    'sold-dollars-sold-qty': 'Dólares Vendidos / Cantidad Vendida',
    'redeemed-qty': 'Cantidad Canjeada',
    'the-quantity-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'La cantidad de tarjetas de regalo utilizadas para pagar todo o parte de un pedido',
    'redeemed-dollars': 'Dólares Canjeados',
    'the-dollar-amount-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'La cantidad de dólares de tarjetas de regalo utilizadas para pagar todo o parte de un pedido',
    'redeemed-average-check': 'Promedio de Cheque Canjeado',
    'redeemed-dollars-redeemed-qty': 'Dólares Canjeados / Cantidad Canjeada',
    'gift-card-summary-catalog-grid-name': 'Resumen de Tarjetas de Regalo',

    // Other Receipts
    'other-receipts-grid-name': 'Otros Recibos',
    'other-receipts-grid-footer': 'Si el rango de fechas incluye una fecha con un RBD, este informe puede no coincidir con el Libro de Caja.',
    'other-receipts-today-grid-name': 'Otros Recibos - Hoy',
    'other-receipts-detail-grid-name': 'Detalles de Otros Recibos',

    // Billable Sales / Safe Counts
    'billable-sales-grid-name': 'Ventas facturables',
    'safe-counts-grid-name': 'Conteos de Caja',

    // ByMenuItemSelector
    'by-menu-item': 'Por Artículo del Menú',

    // Cash Statistics (standard)
    'cash-statistics': 'Estadísticas de Efectivo',
    'by-date': 'Por Fecha',
    'cash-statistics-analysis': 'Análisis de Estadísticas de Efectivo',

    // Legacy camelCase keys (kept for backward compatibility with existing code)
    'drawer': 'Cajón',
    'safeCount': 'Conteo de Caja Fuerte',
    'cashOverShort': 'Sobrante/Faltante de Caja',
    'cashOverShortDescription': 'Sobrante/Faltante es igual al Depósito Esperado menos el Efectivo Esperado.',
    'projectedDeposit': 'Depósito Proyectado',
    'foreignCurrencyDeposit': 'Depósito de Moneda Extranjera',
    'depositCrimeLoss': 'Pérdida por Delito de Depósito',
    'pettyCashReimbursement': 'Reembolso de Caja Chica',
    'actualDeposit': 'Depósito Real',
    'foreignCurrency': 'Moneda Extranjera',
    'expectedCash': 'Efectivo Esperado',
    'posOverrings': 'Anulaciones POS',
    'cashRefund': 'Reembolso en Efectivo',
    'giftCertificatesRedeemed': 'Certificados de Regalo Canjeados',
    'giftCardsRedeemed': 'Tarjetas de Regalo Canjeadas',
    'billableSales': 'Ventas Facturables',
    'delivery3rdPartyGross': 'Entrega de Terceros Bruto',
    'cashlessSales': 'Ventas sin Efectivo',
    'mobileCashless': 'Móvil sin Efectivo',
    'inStoreCashless': 'En Tienda sin Efectivo',
    'denotesReconstructedMetric': '# denota una métrica reconstruida',

    // CashsheetReceipt (MT redesign)
    'cs-breakdown': 'Desglose',
    'cs-net-sales-by-channel': 'Ventas Netas por Canal',
    'cs-taxable-sales': 'Ventas Gravables',
    'cs-delivery-3rd-party': 'Terceros',
    'cs-delivery-internal': 'Interno',
    'cs-transactions': 'Transacciones',
    'cs-pct-of-gross': '{pct} de brutas',
    'cs-pct-of-net': '{pct} de netas',
    'cs-avg-check': 'Cheque promedio {amt}',
    'cs-drawer-reconciliation': 'Conciliación de caja',
    'cs-where-the-net-came-from': 'De dónde vienen las ventas netas',
    'cs-error-loading': 'Ocurrió un error al cargar la hoja de caja.',
    'cs-hide-zero-rows': 'Ocultar filas en cero',
    'cs-vs-ly': 'vs AA {pct}',
    'cs-deposit-short': 'Depósito faltante',
    'cs-deposit-over': 'Depósito sobrante',
    'cs-total-surcharges': 'Total Recargos',
  },
  // Note: "Deposit 1/2" under Taxes/Fees is the bottle deposit (consigne),
  // not the bank deposit handled by the DepositWidget keys further down.
  fr: {
    // Migrated from <i18n> SFC blocks (#6500)
    'cashless-detail': 'Cashless Detail', // TODO(#6335): needs French
    'detail': 'Detail', // TODO(#6335): needs French
    'cashsheet-download': 'Cashsheet Download', // TODO(#6335): needs French
    // CashSheet
    'receipt': 'Reçu',
    'download': 'Télécharger',
    'cashSheet': 'Feuille de caisse',
    'otherInfo': 'Autres informations',
    'cash-sheet-download': 'Téléchargement de la feuille de caisse',

    // CashSheetOther
    'other-info': 'Autres informations',
    'adjusted-figures': 'Chiffres ajustés',
    'reconstructed-day': 'Journée reconstituée',
    'pos-removals': 'Caisses retirées',
    'pos-insertions': 'Caisses ajoutées',
    'rollover': 'Remise à zéro',
    'adjustments': 'Ajustements',
    'weather': 'Météo',
    'comments': 'Commentaires',
    'store-open': 'Ouverture du restaurant',
    'date-time': 'Date/heure',
    'store-open-user': 'Utilisateur ouverture',
    'pos-close': 'Clôture caisse',
    'pos-close-user': 'Utilisateur clôture caisse',
    'bdc-close': 'Clôture BDC',
    'bdc-close-user': 'Utilisateur clôture BDC',
    'weather-and-comments': 'Météo et commentaires',
    'open-close': 'Ouverture/clôture',
    'business-date': 'Date d’activité',
    'rbd-activation-needed': 'Activation RBD requise',
    'rbd-activations-needed': 'Activations RBD requises',
    'rbd-activation-needs-completion': 'activation RBD doit être finalisée',
    'rbd-activations-need-completion': 'activations RBD doivent être finalisées',

    // RbdActivationDetails
    'rbd-activation-details': 'Détails de l’activation RBD',
    'location': 'Site',
    'date': 'Date',
    'status': 'Statut',

    // CashsheetWidget
    'description': 'Description',
    'qty': 'Qté',
    'amt': 'Mnt',

    // SalesWidget
    'gross-sales': 'Ventes brutes',
    'forever-reading-diff': 'Écart relevé permanent',
    'overrings': 'Surenregistrements',
    'cash-refund-cashout': 'Remboursement espèces / sortie de caisse',
    'cashless-refund': 'Remboursement sans espèces',
    'gift-card-sold': 'Cartes cadeaux vendues',
    'gift-cert-sold': 'Bons cadeaux vendus',
    'manual-refund-overrings': 'Remboursements / surenregistrements manuels',
    'gma-delivery-driver-tips': 'Pourboires livreurs GMA',
    'other-receipts': 'Autres recettes',
    'taxes-fees': 'Taxes / frais',
    'total-tax': 'Total des taxes',
    'deposit-1': 'Consigne 1',
    'deposit-2': 'Consigne 2',
    'fee-1': 'Frais 1',
    'fee-2': 'Frais 2',
    'eat-in': 'Sur place',
    'mobile-eat-in-tax': 'Taxe sur place mobile',
    'take-out': 'À emporter',
    'mobile-takeout-tax': 'Taxe à emporter mobile',
    'delivery-total-tax': 'Total des taxes livraison',
    'door-dash-tax': 'Taxe DoorDash',
    'door-dash-1AD-tax': 'Taxe DoorDash 1AD',
    'uber-eats-tax': 'Taxe Uber Eats',
    'uber-eats-1AD-tax': 'Taxe Uber Eats 1AD',
    'grub-hub-tax': 'Taxe Grub Hub',
    'grub-hub-1AD-tax': 'Taxe Grub Hub 1AD',
    'net-sales': 'Ventes nettes',
    'product-sales': 'Ventes produits',
    'non-product-sales': 'Ventes hors produits',
    'sales': 'Ventes',
    'net-sales-is-equal': 'Les ventes nettes correspondent aux ventes brutes moins les remises, les remboursements et les taxes.',
    'denotes-a-reconstructed-metric': 'signale un indicateur reconstitué',
    'kraven-tax': 'Taxe Kraven',
    'kraven-tax-1': 'Taxe Kraven 1',
    'kraven-tax-2': 'Taxe Kraven 2',
    'kraven-tax-3': 'Taxe Kraven 3',
    'kraven-tax-4': 'Taxe Kraven 4',
    'monchis-tax': 'Taxe Monchis',
    'monchis-tax-1': 'Taxe Monchis 1',
    'monchis-tax-2': 'Taxe Monchis 2',
    'monchis-tax-3': 'Taxe Monchis 3',
    'monchis-tax-4': 'Taxe Monchis 4',
    'pedidos-ya-tax': 'Taxe PedidosYa',
    'pedidos-ya-tax-1': 'Taxe PedidosYa 1',
    'pedidos-ya-tax-2': 'Taxe PedidosYa 2',
    'pedidos-ya-tax-3': 'Taxe PedidosYa 3',
    'pedidos-ya-tax-4': 'Taxe PedidosYa 4',

    // DepositWidget
    'deposit': 'Dépôt',
    'cash-over-short-is-equal': 'L’excédent/manquant de caisse correspond au dépôt attendu moins les espèces attendues.',
    'denotes-reconstructed-metric': '# signale un indicateur reconstitué',
    'projected-deposit': 'Dépôt prévu',
    'foreign-currency-deposit': 'Dépôt en devises étrangères',
    'deposit-crime-loss': 'Perte de dépôt pour vol',
    'petty-cash-reimbursement': 'Remboursement de petite caisse',
    'actual-deposit': 'Dépôt réel',
    'cash-over-short': 'Excédent/manquant de caisse',
    'foreign-currency': 'Devises étrangères',
    'expected-cash': 'Espèces attendues',
    'pos-overrings': 'Surenregistrements caisse',
    'cash-refund': 'Remboursement espèces',
    'gift-certificates-redeemed': 'Bons cadeaux utilisés',
    'gift-cards-redeemed': 'Cartes cadeaux utilisées',
    'mc-balance-redeemed': 'Solde Arch Card utilisé',
    'billable-sales': 'Ventes facturables',
    'delivery-3rd-party-gross': 'Livraison tiers brut',
    'cashless-sales': 'Ventes sans espèces',
    'mobile-cashless': 'Sans espèces mobile',
    'in-store-cashless': 'Sans espèces en restaurant',
    'prior-day-cash-in-deposit': 'Espèces de la veille dans le dépôt',
    'cash-for-next-day-deposit': 'Espèces pour le dépôt du lendemain',
    'penny-rounding': '(+/-) Arrondi au centime',

    // AdditionalInfoWidget
    'additional-info': 'Informations complémentaires',
    'average-check': 'Ticket moyen',
    'non-product-sales-amt': 'Mnt ventes hors produits',
    'eat-in-sales': 'Ventes sur place',
    'take-out-sales': 'Ventes à emporter',
    'drive-thru-sales': 'Ventes Drive',
    'breakfast-sales': 'Ventes petit-déjeuner',
    'non-taxable-sales': 'Ventes non taxables',
    'tax-exempt-sales': 'Ventes exonérées de taxes',
    'rmhc': 'RMHC',
    'rmhc-cash': 'RMHC espèces',
    'rmhc-cashless': 'RMHC sans espèces',
    'net-sales-digital': 'Ventes nettes digitales',
    'kiosk': 'Borne',
    'eat-in-kiosk': 'Sur place (borne)',
    'take-out-kiosk': 'À emporter (borne)',
    'mop': 'MOP',
    'eat-in-mop': 'Sur place (MOP)',
    'take-out-mop': 'À emporter (MOP)',
    'delivery': 'Livraison',
    'doordash': 'DoorDash',
    'ubereats': 'UberEats',
    'grubhub': 'GrubHub',
    'discounts': 'Remises',
    'tred-before': 'TRED avant',
    'tred-after': 'TRED après',
    'discount': 'Remise',
    'electronic-discount': 'Remise électronique',
    'promo': 'Promo',
    'electronic-promo': 'Promo électronique',
    'employee-meals': 'Repas employés',
    'manager-meals': 'Repas managers',
    'all-coupons': 'Tous les coupons',
    'coupon': 'Coupon',
    'monchis': 'Monchis',
    'monchisAmt': 'Montant Monchis',
    'monchisQty': 'Quantité Monchis',
    'pedidos-ya': 'PedidosYa',
    'pedidosYaAmt': 'Montant PedidosYa',
    'pedidosYaQty': 'Quantité PedidosYa',

    // Adyen (shared)
    'adyen-essentials': 'Adyen Essentials',
    'no-data-description': 'peut s’expliquer par des accords DataPass non signés ou par des rapports mal configurés dans le portail ADYEN.',
    'please-review': 'Veuillez consulter',
    'adyen-reporting-essentials': 'Adyen Reporting Essentials',
    'for-details': 'pour plus de détails',
    'adyen-grid-footer': 'Si aucune donnée n’apparaît pour un ou plusieurs sites, vérifiez que l’approbation DataPass a bien été effectuée et que le fichier est au format CSV. Les données seront entièrement mises à jour pour les dates postérieures à la modification.',
    'adyen-source-of-truth': 'Le portail Adyen fait foi. Pour investiguer les écarts signalés dans le rapport QSRSoft, l’étape suivante consiste à vérifier les données directement dans le portail Adyen.',
    'for-more-details': 'Pour plus de détails, consultez',
    'adyen-settlement-delay': 'Remarque : les données de règlement accusent généralement 2 jours de retard. Le week-end, ce délai peut atteindre 4 à 5 jours.',
    'file-pending': 'Fichier en attente',
    'settlement-not-received': 'Règlement non reçu',
    'settlement-partially-received': 'Règlement partiellement reçu',
    'settlement-missing': 'Règlement manquant',
    'record-status': 'Statut de l’enregistrement',
    'adyen-variance-summary': 'Synthèse des écarts Adyen',
    'show-flagged': 'Afficher les éléments signalés',
    'by-gross-variance': 'Par écart brut',
    'adyen-variance-detail': 'Détail des écarts Adyen',
    'adyen-payout-summary': 'Synthèse des versements Adyen',
    'adyen-Adjustment': 'Ajustement Adyen',
    'adjustment': 'Ajustement',
    'payout-summary': 'Synthèse des versements',
    'variance-detail': 'Détail des écarts',
    'variance-summary': 'Synthèse des écarts',
    'visa': 'Visa',
    'master': 'Mastercard',
    'discover': 'Discover',
    'amex': 'Amex',
    'other': 'Autre',
    'debit': 'Débit',
    'batch-number': 'Numéro de lot',
    'batch-number-description': 'Numéro de lot de règlement',

    // Deposits
    'deposit-summary-grid-name': 'Synthèse des dépôts',
    'by-store': 'Par restaurant',
    'deposit-code': 'Code de dépôt',
    'deposit-code-description': 'Il peut s’agir de codes de périodes standard (petit-déjeuner, journée, soirée, etc.) ou de codes personnalisés définis dans C&I.',
    'petty-cash-amt': 'Mnt petite caisse',
    'petty-cash-amt-description': 'Montants de petite caisse remboursés à partir des dépôts',
    'deposit-amt': 'Mnt du dépôt',
    'deposit-amt-description': 'Montant du dépôt',
    'deposit-details-grid-name': 'Détails des dépôts',
    'deposit-details-analysis': 'Analyse du détail des dépôts',
    'deposit-details-grid-footer': '* Les lignes surlignées signalent un écart entre le « Mnt du dépôt » et le montant du « Dépôt validé »',
    'details': 'Détail',
    'summary': 'Synthèse',

    // Cashless
    'cashless-summary': 'Synthèse sans espèces',
    'cashless-by-store': 'Sans espèces par restaurant',
    'cashless-details': 'Détails sans espèces',
    'cashless-transactions': 'Transactions sans espèces',
    'mobile-cashless-grid-name': 'Sans espèces mobile',
    'time': 'Heure',
    'time-for-cashless-gc': 'Heure d’un client sans espèces',
    'cashless-origin': 'Origine sans espèces',
    'cashless-gc-paid-through-register-or-digital-app': 'Client sans espèces ayant payé en caisse ou via l’application mobile (en restaurant ou mobile)',
    'register-number': 'N° de caisse',
    'which-cash-register-the-cashless-gc-was-finalized-on': 'Caisse sur laquelle la transaction sans espèces a été finalisée',
    'type': 'Type',
    'cashless-gc-type': 'Type de transaction sans espèces',
    'card-type': 'Type de carte',
    'credit-debit-card-type': 'Type de carte de crédit/débit (Visa, Mastercard, Discover, Amex, Débit)',
    'card-number': 'N° de carte',
    'credit-debit-card-number': 'Numéro de carte de crédit/débit',
    'total-no-gift-card': 'Total hors cartes cadeaux',
    'total-with-gift-card': 'Total avec cartes cadeaux',
    'pos-diff-no-gift-card': 'Écart caisse hors cartes cadeaux',
    'arch-card': 'Arch Card',
    'gcard': 'Carte cadeau',
    'auth-number': 'N° d’autorisation',
    'authorization-number-received-from-credit-card-processor': 'Numéro d’autorisation reçu du processeur de cartes bancaires',
    'amount': 'Mnt',
    'amount-authorized-on-the-credit-card': 'Montant autorisé sur la carte bancaire',
    'sequence-number': 'N° de séquence',
    'this-number-reflects-the-order-of-the-gc-by-register': 'Ce numéro indique l’ordre des transactions client par caisse',
    'linked-payment': 'Paiement lié',
    'whether-the-customer-paid-for': 'Indique si le client a payé une commande en restaurant avec son appareil mobile associé',
    'Summary': 'Synthèse',
    'Detail': 'Détail',
    'Mobile': 'Mobile',

    // Tax
    'tax-details-grid-name': 'Détails des taxes',
    'tax-exempt-grid-name': 'Exonération de taxes',
    'tax-exempt-today-grid-name': 'Exonération de taxes - Aujourd’hui',
    'company-number': 'Numéro de société',
    'company-number-description': 'Numéro de société',
    'cust-name': 'Nom du client',
    'customer-name-description': 'Nom du client',
    'company-name': 'Raison sociale',
    'company-name-description': 'Raison sociale',
    'company-address': 'Adresse de la société',
    'company-address-description': 'Adresse de la société',
    'tax-exempt-amt': 'Mnt',
    'tax-exempt-amt-description': 'Montant exonéré de taxes',
    'payment-type': 'Type de paiement',
    'payment-type-description': 'Type de paiement',
    'adjusted-description': 'Un ou plusieurs chiffres de la feuille de caisse ont été ajustés pour la période.',
    'reconstructed-description': 'Une ou plusieurs journées ont été reconstituées via l’application Cash and Inventory du restaurant.',
    'register-removed-description': 'Une caisse a été retirée du système de caisse pendant les heures d’ouverture.',
    'register-added-description': 'Une caisse a été ajoutée au système de caisse pendant les heures d’ouverture.',
    'rollover-description': 'Si une caisse fonctionne suffisamment longtemps, le relevé permanent finit par « repasser » à 0. Le cas échéant, l’écart de remise à zéro est affiché ici.',
    'weather-note-description': 'Note sur la météo saisie par le restaurant',
    'closing-manager-note-description': 'Note saisie par le manager de fermeture pour consigner toute information qu’il juge importante',
    'delivery-tax-total': 'Total des taxes livraison',
    'delivery-tax-total-description': 'Somme des taxes sur les commandes en livraison, tous prestataires confondus',
    'delivery-doordash-tax': 'Taxe livraison DoorDash',
    'delivery-doordash-tax-description': 'Total des taxes de livraison pour les commandes DoorDash',
    'delivery-doordash-1-ad-tax': 'Taxe livraison DoorDash 1-AD',
    'delivery-doordash-1-ad-tax-description': 'Total des taxes de livraison pour les commandes DoorDash intégrées',
    'delivery-doordash-tax-1': 'Taxe livraison DoorDash 1',
    'delivery-doordash-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-1': 'Taxe livraison DoorDash 1-AD 1',
    'delivery-doordash-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-tax-2': 'Taxe livraison DoorDash 2',
    'delivery-doordash-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-2': 'Taxe livraison DoorDash 1-AD 2',
    'delivery-doordash-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-tax-3': 'Taxe livraison DoorDash 3',
    'delivery-doordash-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-3': 'Taxe livraison DoorDash 1-AD 3',
    'delivery-doordash-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-tax-4': 'Taxe livraison DoorDash 4',
    'delivery-doordash-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-4': 'Taxe livraison DoorDash 1-AD 4',
    'delivery-doordash-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax': 'Taxe livraison UberEats',
    'delivery-ubereats-tax-description': 'Total des taxes de livraison pour les commandes UberEats',
    'delivery-ubereats-1-ad-tax': 'Taxe livraison UberEats 1-AD',
    'delivery-ubereats-1-ad-tax-description': 'Total des taxes de livraison pour les commandes UberEats intégrées',
    'delivery-ubereats-tax-1': 'Taxe livraison UberEats 1',
    'delivery-ubereats-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-1': 'Taxe livraison UberEats 1-AD 1',
    'delivery-ubereats-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax-2': 'Taxe livraison UberEats 2',
    'delivery-ubereats-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-2': 'Taxe livraison UberEats 1-AD 2',
    'delivery-ubereats-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax-3': 'Taxe livraison UberEats 3',
    'delivery-ubereats-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-3': 'Taxe livraison UberEats 1-AD 3',
    'delivery-ubereats-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax-4': 'Taxe livraison UberEats 4',
    'delivery-ubereats-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-4': 'Taxe livraison UberEats 1-AD 4',
    'delivery-ubereats-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax': 'Taxe livraison GrubHub',
    'delivery-grubhub-tax-description': 'Total des taxes de livraison pour les commandes GrubHub',
    'delivery-grubhub-1-ad-tax': 'Taxe livraison GrubHub 1-AD',
    'delivery-grubhub-1-ad-tax-description': 'Total des taxes de livraison pour les commandes GrubHub intégrées',
    'delivery-grubhub-tax-1': 'Taxe livraison GrubHub 1',
    'delivery-grubhub-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-1': 'Taxe livraison GrubHub 1-AD 1',
    'delivery-grubhub-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax-2': 'Taxe livraison GrubHub 2',
    'delivery-grubhub-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-2': 'Taxe livraison GrubHub 1-AD 2',
    'delivery-grubhub-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax-3': 'Taxe livraison GrubHub 3',
    'delivery-grubhub-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-3': 'Taxe livraison GrubHub 1-AD 3',
    'delivery-grubhub-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax-4': 'Taxe livraison GrubHub 4',
    'delivery-grubhub-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-4': 'Taxe livraison GrubHub 1-AD 4',
    'delivery-grubhub-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax': 'Taxe livraison PostMates',
    'delivery-postmates-tax-description': 'Total des taxes de livraison pour les commandes PostMates',
    'delivery-postmates-1-ad-tax': 'Taxe livraison PostMates 1-AD',
    'delivery-postmates-1-ad-tax-description': 'Total des taxes de livraison pour les commandes PostMates intégrées',
    'delivery-postmates-tax-1': 'Taxe livraison PostMates 1',
    'delivery-postmates-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-1': 'Taxe livraison PostMates 1-AD 1',
    'delivery-postmates-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax-2': 'Taxe livraison PostMates 2',
    'delivery-postmates-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-2': 'Taxe livraison PostMates 1-AD 2',
    'delivery-postmates-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax-3': 'Taxe livraison PostMates 3',
    'delivery-postmates-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-3': 'Taxe livraison PostMates 1-AD 3',
    'delivery-postmates-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax-4': 'Taxe livraison PostMates 4',
    'delivery-postmates-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-4': 'Taxe livraison PostMates 1-AD 4',
    'delivery-postmates-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-1': 'Taxe sur place mobile 1',
    'mobile-eat-in-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-2': 'Taxe sur place mobile 2',
    'mobile-eat-in-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-3': 'Taxe sur place mobile 3',
    'mobile-eat-in-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-4': 'Taxe sur place mobile 4',
    'mobile-eat-in-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-total': 'Total taxe sur place mobile',
    'mobile-eat-in-tax-total-description': 'Taxes sur les commandes mobiles consommées au restaurant',
    'mobile-takeout-tax-1': 'Taxe à emporter mobile 1',
    'mobile-takeout-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes mobiles emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-2': 'Taxe à emporter mobile 2',
    'mobile-takeout-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes mobiles emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-3': 'Taxe à emporter mobile 3',
    'mobile-takeout-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes mobiles emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-4': 'Taxe à emporter mobile 4',
    'mobile-takeout-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes mobiles emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-total': 'Total taxe à emporter mobile',
    'mobile-takeout-tax-total-description': 'Taxes sur les commandes mobiles emportées hors du restaurant pour consommation',
    'eat-in-tax-amt': 'Mnt taxe sur place',
    'eat-in-tax-amt-description': 'Total des taxes pour les commandes consommées au restaurant',
    'eat-in-tax-1': 'Taxe sur place 1',
    'eat-in-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'eat-in-tax-2': 'Taxe sur place 2',
    'eat-in-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'eat-in-tax-3': 'Taxe sur place 3',
    'eat-in-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'eat-in-tax-4': 'Taxe sur place 4',
    'eat-in-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-amt': 'Mnt taxe à emporter',
    'takeout-tax-amt-description': 'Total des taxes pour les commandes emportées hors du restaurant pour consommation',
    'takeout-tax-1': 'Taxe à emporter 1',
    'takeout-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-2': 'Taxe à emporter 2',
    'takeout-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-3': 'Taxe à emporter 3',
    'takeout-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-4': 'Taxe à emporter 4',
    'takeout-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes emportées hors du restaurant. Tous les restaurants utilisent la taxe 1 ; certains utilisent aussi les taxes 2, 3 et 4',
    'fee-1-amount': 'Montant des frais 1',
    'fee-1-amount-description': 'La caisse permet de collecter des frais (distincts des taxes et généralement non taxés)',
    'fee-2-amount': 'Montant des frais 2',
    'fee-2-amount-description': 'La caisse permet de collecter des frais (distincts des taxes et généralement non taxés)',
    'deposit-1-amount': 'Montant de la consigne 1',
    'deposit-1-amount-description': 'Montant de toute consigne 1 facturée au client pour les bouteilles',
    'deposit-2-amount': 'Montant de la consigne 2',
    'deposit-2-amount-description': 'Montant de toute consigne 2 facturée au client pour les bouteilles',
    'deposit-amt-bottles-description': 'Montant total des consignes facturées au client pour les bouteilles',

    // Register Audit
    'register-audit': 'Audit des caisses',
    'this-report-aggregates-footnote': 'Ce rapport agrège les valeurs par tiroir-caisse. Dans les restaurants ouverts 24 h/24, un tiroir peut chevaucher la fin de journée d’activité et les valeurs peuvent ne pas correspondre à celles de la feuille de caisse',
    'by-location': 'Par site',
    'sum-all-locations': 'Cumul de tous les sites',
    'by-employee': 'Par employé',
    'employee-drawer': 'Tiroir employé',
    'cashier': 'Caissier',
    'cashier-name': 'Nom du caissier',
    'manager': 'Manager',
    'manager-name': 'Nom du manager',
    'preparer': 'Préparateur',
    'preparer-name': 'Nom du préparateur',
    'cash-out-time': 'Heure de clôture du tiroir',
    'time-the-cash-register-drawer-was-closed': 'Heure à laquelle le tiroir-caisse a été fermé',
    'emp-name': 'Nom employé',
    'employee-name': 'Nom de l’employé',
    'Register': 'Caisse',
    'By-Location': 'Par site',
    'By-Employee': 'Par employé',
    'Employee': 'Employé',

    // Gift Card Summary
    'gift-card-summary': 'Synthèse des cartes cadeaux',
    'net-qty': 'Qté nette',
    'sold-qty-redeemed-qty': 'Qté vendue - Qté utilisée',
    'net-amt': 'Mnt net',
    'sold-dollars-redeemed-dollars': 'Montant vendu - Montant utilisé',
    'sold-qty': 'Qté vendue',
    'the-quantity-of-gift-cards-activated-or-reloaded': 'Nombre de cartes cadeaux activées ou rechargées',
    'sold-dollars': 'Montant vendu',
    'the-dollar-amount-of-gift-cards-activated-or-reloaded': 'Montant en dollars des cartes cadeaux activées ou rechargées',
    'sold-average-check': 'Ticket moyen vendu',
    'sold-dollars-sold-qty': 'Montant vendu / Qté vendue',
    'redeemed-qty': 'Qté utilisée',
    'the-quantity-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'Nombre de cartes cadeaux utilisées pour payer tout ou partie d’une commande',
    'redeemed-dollars': 'Montant utilisé',
    'the-dollar-amount-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'Montant en dollars des cartes cadeaux utilisées pour payer tout ou partie d’une commande',
    'redeemed-average-check': 'Ticket moyen utilisé',
    'redeemed-dollars-redeemed-qty': 'Montant utilisé / Qté utilisée',
    'gift-card-summary-catalog-grid-name': 'Synthèse des cartes cadeaux',

    // Other Receipts
    'other-receipts-grid-name': 'Autres recettes',
    'other-receipts-grid-footer': 'Si la plage de dates comprend une date avec un RBD, ce rapport peut ne pas correspondre à la feuille de caisse.',
    'other-receipts-today-grid-name': 'Autres recettes - Aujourd’hui',
    'other-receipts-detail-grid-name': 'Détail des autres recettes',

    // Billable Sales / Safe Counts
    'billable-sales-grid-name': 'Ventes facturables',
    'safe-counts-grid-name': 'Comptages du coffre',

    // ByMenuItemSelector
    'by-menu-item': 'Par article du menu',

    // Cash Statistics (standard)
    'cash-statistics': 'Statistiques de caisse',
    'by-date': 'Par date',
    'cash-statistics-analysis': 'Analyse des statistiques de caisse',

    // Legacy camelCase keys (kept for backward compatibility with existing code)
    'drawer': 'Tiroir-caisse',
    'safeCount': 'Comptage du coffre',
    'cashOverShort': 'Excédent/manquant de caisse',
    'cashOverShortDescription': 'L’excédent/manquant de caisse correspond au dépôt attendu moins les espèces attendues.',
    'projectedDeposit': 'Dépôt prévu',
    'foreignCurrencyDeposit': 'Dépôt en devises étrangères',
    'depositCrimeLoss': 'Perte de dépôt pour vol',
    'pettyCashReimbursement': 'Remboursement de petite caisse',
    'actualDeposit': 'Dépôt réel',
    'foreignCurrency': 'Devises étrangères',
    'expectedCash': 'Espèces attendues',
    'posOverrings': 'Surenregistrements caisse',
    'cashRefund': 'Remboursement espèces',
    'giftCertificatesRedeemed': 'Bons cadeaux utilisés',
    'giftCardsRedeemed': 'Cartes cadeaux utilisées',
    'billableSales': 'Ventes facturables',
    'delivery3rdPartyGross': 'Livraison tiers brut',
    'cashlessSales': 'Ventes sans espèces',
    'mobileCashless': 'Sans espèces mobile',
    'inStoreCashless': 'Sans espèces en restaurant',
    'denotesReconstructedMetric': '# signale un indicateur reconstitué',

    // CashsheetReceipt (MT redesign)
    'cs-breakdown': 'Répartition',
    'cs-net-sales-by-channel': 'Ventes nettes par canal',
    'cs-taxable-sales': 'Ventes taxables',
    'cs-delivery-3rd-party': 'Tiers',
    'cs-delivery-internal': 'Interne',
    'cs-transactions': 'Transactions',
    'cs-pct-of-gross': '{pct} du brut',
    'cs-pct-of-net': '{pct} du net',
    'cs-avg-check': 'Ticket moyen {amt}',
    'cs-drawer-reconciliation': 'Rapprochement de caisse',
    'cs-where-the-net-came-from': 'Origine des ventes nettes',
    'cs-error-loading': 'Une erreur est survenue lors du chargement de la feuille de caisse.',
    'cs-hide-zero-rows': 'Masquer les lignes à zéro',
    'cs-vs-ly': 'vs AP {pct}',
    'cs-deposit-short': 'Dépôt manquant',
    'cs-deposit-over': 'Dépôt excédentaire',
    'cs-total-surcharges': 'Total des surcharges',
  },
  'fr-ca': {
    // Migrated from <i18n> SFC blocks (#6500)
    'cashless-detail': 'Cashless Detail', // TODO(#6335): needs French
    'detail': 'Detail', // TODO(#6335): needs French
    'cashsheet-download': 'Cashsheet Download', // TODO(#6335): needs French
    // CashSheet
    'receipt': 'Reçu',
    'download': 'Télécharger',
    'cashSheet': 'Feuille de caisse',
    'otherInfo': 'Autres renseignements',
    'cash-sheet-download': 'Téléchargement de la feuille de caisse',

    // CashSheetOther
    'other-info': 'Autres renseignements',
    'adjusted-figures': 'Chiffres ajustés',
    'reconstructed-day': 'Journée reconstituée',
    'pos-removals': 'Caisses retirées',
    'pos-insertions': 'Caisses ajoutées',
    'rollover': 'Remise à zéro',
    'adjustments': 'Ajustements',
    'weather': 'Météo',
    'comments': 'Commentaires',
    'store-open': 'Ouverture du restaurant',
    'date-time': 'Date/heure',
    'store-open-user': 'Utilisateur de l’ouverture',
    'pos-close': 'Fermeture PDV',
    'pos-close-user': 'Utilisateur de la fermeture PDV',
    'bdc-close': 'Fermeture BDC',
    'bdc-close-user': 'Utilisateur de la fermeture BDC',
    'weather-and-comments': 'Météo et commentaires',
    'open-close': 'Ouverture/fermeture',
    'business-date': 'Date d’exploitation',
    'rbd-activation-needed': 'Activation RBD requise',
    'rbd-activations-needed': 'Activations RBD requises',
    'rbd-activation-needs-completion': 'activation RBD doit être complétée',
    'rbd-activations-need-completion': 'activations RBD doivent être complétées',

    // RbdActivationDetails
    'rbd-activation-details': 'Détails de l’activation RBD',
    'location': 'Emplacement',
    'date': 'Date',
    'status': 'Statut',

    // CashsheetWidget
    'description': 'Description',
    'qty': 'Qté',
    'amt': 'Mnt',

    // SalesWidget
    'gross-sales': 'Ventes brutes',
    'forever-reading-diff': 'Écart du relevé permanent',
    'overrings': 'Surenregistrements',
    'cash-refund-cashout': 'Remboursement comptant / sortie de caisse',
    'cashless-refund': 'Remboursement sans comptant',
    'gift-card-sold': 'Cartes-cadeaux vendues',
    'gift-cert-sold': 'Chèques-cadeaux vendus',
    'manual-refund-overrings': 'Remboursements / surenregistrements manuels',
    'gma-delivery-driver-tips': 'Pourboires des livreurs GMA',
    'other-receipts': 'Autres recettes',
    'taxes-fees': 'Taxes / frais',
    'total-tax': 'Total des taxes',
    'deposit-1': 'Consigne 1',
    'deposit-2': 'Consigne 2',
    'fee-1': 'Frais 1',
    'fee-2': 'Frais 2',
    'eat-in': 'Sur place',
    'mobile-eat-in-tax': 'Taxe sur place mobile',
    'take-out': 'Pour emporter',
    'mobile-takeout-tax': 'Taxe pour emporter mobile',
    'delivery-total-tax': 'Total des taxes de livraison',
    'door-dash-tax': 'Taxe DoorDash',
    'door-dash-1AD-tax': 'Taxe DoorDash 1AD',
    'uber-eats-tax': 'Taxe Uber Eats',
    'uber-eats-1AD-tax': 'Taxe Uber Eats 1AD',
    'grub-hub-tax': 'Taxe Grub Hub',
    'grub-hub-1AD-tax': 'Taxe Grub Hub 1AD',
    'net-sales': 'Ventes nettes',
    'product-sales': 'Ventes de produits',
    'non-product-sales': 'Ventes hors produits',
    'sales': 'Ventes',
    'net-sales-is-equal': 'Les ventes nettes correspondent aux ventes brutes moins les rabais, les remboursements et les taxes.',
    'denotes-a-reconstructed-metric': 'indique un indicateur reconstitué',
    'kraven-tax': 'Taxe Kraven',
    'kraven-tax-1': 'Taxe Kraven 1',
    'kraven-tax-2': 'Taxe Kraven 2',
    'kraven-tax-3': 'Taxe Kraven 3',
    'kraven-tax-4': 'Taxe Kraven 4',
    'monchis-tax': 'Taxe Monchis',
    'monchis-tax-1': 'Taxe Monchis 1',
    'monchis-tax-2': 'Taxe Monchis 2',
    'monchis-tax-3': 'Taxe Monchis 3',
    'monchis-tax-4': 'Taxe Monchis 4',
    'pedidos-ya-tax': 'Taxe PedidosYa',
    'pedidos-ya-tax-1': 'Taxe PedidosYa 1',
    'pedidos-ya-tax-2': 'Taxe PedidosYa 2',
    'pedidos-ya-tax-3': 'Taxe PedidosYa 3',
    'pedidos-ya-tax-4': 'Taxe PedidosYa 4',

    // DepositWidget
    'deposit': 'Dépôt',
    'cash-over-short-is-equal': 'L’excédent/manque de caisse correspond au dépôt prévu moins le comptant prévu.',
    'denotes-reconstructed-metric': '# indique un indicateur reconstitué',
    'projected-deposit': 'Dépôt prévu',
    'foreign-currency-deposit': 'Dépôt en devises étrangères',
    'deposit-crime-loss': 'Perte de dépôt liée à un vol',
    'petty-cash-reimbursement': 'Remboursement de la petite caisse',
    'actual-deposit': 'Dépôt réel',
    'cash-over-short': 'Excédent/manque de caisse',
    'foreign-currency': 'Devises étrangères',
    'expected-cash': 'Comptant prévu',
    'pos-overrings': 'Surenregistrements PDV',
    'cash-refund': 'Remboursement comptant',
    'gift-certificates-redeemed': 'Chèques-cadeaux échangés',
    'gift-cards-redeemed': 'Cartes-cadeaux échangées',
    'mc-balance-redeemed': 'Solde Arch Card échangé',
    'billable-sales': 'Ventes facturables',
    'delivery-3rd-party-gross': 'Livraison par un tiers - brut',
    'cashless-sales': 'Ventes sans comptant',
    'mobile-cashless': 'Sans comptant mobile',
    'in-store-cashless': 'Sans comptant en restaurant',
    'prior-day-cash-in-deposit': 'Comptant de la veille dans le dépôt',
    'cash-for-next-day-deposit': 'Comptant pour le dépôt du lendemain',
    'penny-rounding': '(+/-) Arrondi du sou',

    // AdditionalInfoWidget
    'additional-info': 'Renseignements supplémentaires',
    'average-check': 'Facture moyenne',
    'non-product-sales-amt': 'Mnt ventes hors produits',
    'eat-in-sales': 'Ventes sur place',
    'take-out-sales': 'Ventes pour emporter',
    'drive-thru-sales': 'Ventes au service au volant',
    'breakfast-sales': 'Ventes du déjeuner',
    'non-taxable-sales': 'Ventes non taxables',
    'tax-exempt-sales': 'Ventes exemptées de taxes',
    'rmhc': 'RMHC',
    'rmhc-cash': 'RMHC comptant',
    'rmhc-cashless': 'RMHC sans comptant',
    'net-sales-digital': 'Ventes nettes numériques',
    'kiosk': 'Borne',
    'eat-in-kiosk': 'Sur place (borne)',
    'take-out-kiosk': 'Pour emporter (borne)',
    'mop': 'MOP',
    'eat-in-mop': 'Sur place (MOP)',
    'take-out-mop': 'Pour emporter (MOP)',
    'delivery': 'Livraison',
    'doordash': 'DoorDash',
    'ubereats': 'UberEats',
    'grubhub': 'GrubHub',
    'discounts': 'Rabais',
    'tred-before': 'TRED avant',
    'tred-after': 'TRED après',
    'discount': 'Rabais',
    'electronic-discount': 'Rabais électronique',
    'promo': 'Promo',
    'electronic-promo': 'Promo électronique',
    'employee-meals': 'Repas des employés',
    'manager-meals': 'Repas des gérants',
    'all-coupons': 'Tous les coupons',
    'coupon': 'Coupon',
    'monchis': 'Monchis',
    'monchisAmt': 'Montant Monchis',
    'monchisQty': 'Quantité Monchis',
    'pedidos-ya': 'PedidosYa',
    'pedidosYaAmt': 'Montant PedidosYa',
    'pedidosYaQty': 'Quantité PedidosYa',

    // Adyen (shared)
    'adyen-essentials': 'Adyen Essentials',
    'no-data-description': 'peut s’expliquer par des ententes DataPass non signées ou par des rapports mal configurés dans le portail ADYEN.',
    'please-review': 'Veuillez consulter',
    'adyen-reporting-essentials': 'Adyen Reporting Essentials',
    'for-details': 'pour les détails',
    'adyen-grid-footer': 'Si aucune donnée n’apparaît pour un ou plusieurs emplacements, veuillez vérifier que l’approbation DataPass a été complétée et que le fichier est au format CSV. Les données seront entièrement mises à jour pour les dates suivant la modification.',
    'adyen-source-of-truth': 'Le portail Adyen constitue la source de référence. Pour examiner les écarts signalés dans le rapport QSRSoft, l’étape suivante consiste à vérifier les données directement dans le portail Adyen.',
    'for-more-details': 'Pour plus de détails, consultez',
    'adyen-settlement-delay': 'Remarque : les données de règlement accusent habituellement 2 jours de retard. La fin de semaine, ce délai peut atteindre 4 à 5 jours.',
    'file-pending': 'Fichier en attente',
    'settlement-not-received': 'Règlement non reçu',
    'settlement-partially-received': 'Règlement partiellement reçu',
    'settlement-missing': 'Règlement manquant',
    'record-status': 'Statut de l’enregistrement',
    'adyen-variance-summary': 'Sommaire des écarts Adyen',
    'show-flagged': 'Afficher les éléments signalés',
    'by-gross-variance': 'Par écart brut',
    'adyen-variance-detail': 'Détail des écarts Adyen',
    'adyen-payout-summary': 'Sommaire des versements Adyen',
    'adyen-Adjustment': 'Ajustement Adyen',
    'adjustment': 'Ajustement',
    'payout-summary': 'Sommaire des versements',
    'variance-detail': 'Détail des écarts',
    'variance-summary': 'Sommaire des écarts',
    'visa': 'Visa',
    'master': 'Mastercard',
    'discover': 'Discover',
    'amex': 'Amex',
    'other': 'Autre',
    'debit': 'Débit',
    'batch-number': 'Numéro de lot',
    'batch-number-description': 'Numéro de lot de règlement',

    // Deposits
    'deposit-summary-grid-name': 'Sommaire des dépôts',
    'by-store': 'Par restaurant',
    'deposit-code': 'Code de dépôt',
    'deposit-code-description': 'Il peut s’agir de codes de périodes standards (déjeuner, jour, soir, etc.) ou de codes personnalisés définis dans C&I.',
    'petty-cash-amt': 'Mnt petite caisse',
    'petty-cash-amt-description': 'Sommes de petite caisse remboursées à même les dépôts',
    'deposit-amt': 'Mnt du dépôt',
    'deposit-amt-description': 'Montant du dépôt',
    'deposit-details-grid-name': 'Détails des dépôts',
    'deposit-details-analysis': 'Analyse du détail des dépôts',
    'deposit-details-grid-footer': '* Les rangées surlignées indiquent un écart entre le « Mnt du dépôt » et le montant du « Dépôt validé »',
    'details': 'Détail',
    'summary': 'Sommaire',

    // Cashless
    'cashless-summary': 'Sommaire sans comptant',
    'cashless-by-store': 'Sans comptant par restaurant',
    'cashless-details': 'Détails sans comptant',
    'cashless-transactions': 'Transactions sans comptant',
    'mobile-cashless-grid-name': 'Sans comptant mobile',
    'time': 'Heure',
    'time-for-cashless-gc': 'Heure d’un client sans comptant',
    'cashless-origin': 'Origine sans comptant',
    'cashless-gc-paid-through-register-or-digital-app': 'Client sans comptant ayant payé à la caisse ou par l’application mobile (en restaurant ou mobile)',
    'register-number': 'N° de caisse',
    'which-cash-register-the-cashless-gc-was-finalized-on': 'Caisse enregistreuse sur laquelle la transaction sans comptant a été finalisée',
    'type': 'Type',
    'cashless-gc-type': 'Type de transaction sans comptant',
    'card-type': 'Type de carte',
    'credit-debit-card-type': 'Type de carte de crédit ou de débit (Visa, Mastercard, Discover, Amex, Débit)',
    'card-number': 'N° de carte',
    'credit-debit-card-number': 'Numéro de carte de crédit ou de débit',
    'total-no-gift-card': 'Total sans cartes-cadeaux',
    'total-with-gift-card': 'Total avec cartes-cadeaux',
    'pos-diff-no-gift-card': 'Écart PDV sans cartes-cadeaux',
    'arch-card': 'Arch Card',
    'gcard': 'Carte-cadeau',
    'auth-number': 'N° d’autorisation',
    'authorization-number-received-from-credit-card-processor': 'Numéro d’autorisation reçu du processeur de cartes de crédit',
    'amount': 'Mnt',
    'amount-authorized-on-the-credit-card': 'Montant autorisé sur la carte de crédit',
    'sequence-number': 'N° de séquence',
    'this-number-reflects-the-order-of-the-gc-by-register': 'Ce numéro indique l’ordre des transactions client par caisse',
    'linked-payment': 'Paiement lié',
    'whether-the-customer-paid-for': 'Indique si le client a payé une commande en restaurant avec son appareil mobile lié',
    'Summary': 'Sommaire',
    'Detail': 'Détail',
    'Mobile': 'Mobile',

    // Tax
    'tax-details-grid-name': 'Détails des taxes',
    'tax-exempt-grid-name': 'Exemption de taxes',
    'tax-exempt-today-grid-name': 'Exemption de taxes - Aujourd’hui',
    'company-number': 'Numéro d’entreprise',
    'company-number-description': 'Numéro d’entreprise',
    'cust-name': 'Nom du client',
    'customer-name-description': 'Nom du client',
    'company-name': 'Nom de l’entreprise',
    'company-name-description': 'Nom de l’entreprise',
    'company-address': 'Adresse de l’entreprise',
    'company-address-description': 'Adresse de l’entreprise',
    'tax-exempt-amt': 'Mnt',
    'tax-exempt-amt-description': 'Montant exempté de taxes',
    'payment-type': 'Type de paiement',
    'payment-type-description': 'Type de paiement',
    'adjusted-description': 'Un ou plusieurs chiffres de la feuille de caisse ont été ajustés pour la période.',
    'reconstructed-description': 'Une ou plusieurs journées ont été reconstituées au moyen de l’application Cash and Inventory du restaurant.',
    'register-removed-description': 'Une caisse a été retirée du système PDV pendant les heures d’ouverture.',
    'register-added-description': 'Une caisse a été ajoutée au système PDV pendant les heures d’ouverture.',
    'rollover-description': 'Si une caisse fonctionne assez longtemps, le relevé permanent finit par « revenir » à 0. Le cas échéant, l’écart de remise à zéro est affiché ici.',
    'weather-note-description': 'Note sur la météo saisie par le restaurant',
    'closing-manager-note-description': 'Note saisie par le gérant de fermeture pour consigner tout renseignement qu’il juge important',
    'delivery-tax-total': 'Total des taxes de livraison',
    'delivery-tax-total-description': 'Somme des taxes sur les commandes en livraison pour tous les fournisseurs',
    'delivery-doordash-tax': 'Taxe de livraison DoorDash',
    'delivery-doordash-tax-description': 'Total des taxes de livraison pour les commandes DoorDash',
    'delivery-doordash-1-ad-tax': 'Taxe de livraison DoorDash 1-AD',
    'delivery-doordash-1-ad-tax-description': 'Total des taxes de livraison pour les commandes DoorDash intégrées',
    'delivery-doordash-tax-1': 'Taxe de livraison DoorDash 1',
    'delivery-doordash-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-1': 'Taxe de livraison DoorDash 1-AD 1',
    'delivery-doordash-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-tax-2': 'Taxe de livraison DoorDash 2',
    'delivery-doordash-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-2': 'Taxe de livraison DoorDash 1-AD 2',
    'delivery-doordash-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-tax-3': 'Taxe de livraison DoorDash 3',
    'delivery-doordash-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-3': 'Taxe de livraison DoorDash 1-AD 3',
    'delivery-doordash-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-tax-4': 'Taxe de livraison DoorDash 4',
    'delivery-doordash-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes DoorDash. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-doordash-1-ad-tax-4': 'Taxe de livraison DoorDash 1-AD 4',
    'delivery-doordash-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes DoorDash intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax': 'Taxe de livraison UberEats',
    'delivery-ubereats-tax-description': 'Total des taxes de livraison pour les commandes UberEats',
    'delivery-ubereats-1-ad-tax': 'Taxe de livraison UberEats 1-AD',
    'delivery-ubereats-1-ad-tax-description': 'Total des taxes de livraison pour les commandes UberEats intégrées',
    'delivery-ubereats-tax-1': 'Taxe de livraison UberEats 1',
    'delivery-ubereats-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-1': 'Taxe de livraison UberEats 1-AD 1',
    'delivery-ubereats-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax-2': 'Taxe de livraison UberEats 2',
    'delivery-ubereats-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-2': 'Taxe de livraison UberEats 1-AD 2',
    'delivery-ubereats-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax-3': 'Taxe de livraison UberEats 3',
    'delivery-ubereats-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-3': 'Taxe de livraison UberEats 1-AD 3',
    'delivery-ubereats-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-tax-4': 'Taxe de livraison UberEats 4',
    'delivery-ubereats-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes UberEats. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-ubereats-1-ad-tax-4': 'Taxe de livraison UberEats 1-AD 4',
    'delivery-ubereats-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes UberEats intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax': 'Taxe de livraison GrubHub',
    'delivery-grubhub-tax-description': 'Total des taxes de livraison pour les commandes GrubHub',
    'delivery-grubhub-1-ad-tax': 'Taxe de livraison GrubHub 1-AD',
    'delivery-grubhub-1-ad-tax-description': 'Total des taxes de livraison pour les commandes GrubHub intégrées',
    'delivery-grubhub-tax-1': 'Taxe de livraison GrubHub 1',
    'delivery-grubhub-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-1': 'Taxe de livraison GrubHub 1-AD 1',
    'delivery-grubhub-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax-2': 'Taxe de livraison GrubHub 2',
    'delivery-grubhub-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-2': 'Taxe de livraison GrubHub 1-AD 2',
    'delivery-grubhub-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax-3': 'Taxe de livraison GrubHub 3',
    'delivery-grubhub-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-3': 'Taxe de livraison GrubHub 1-AD 3',
    'delivery-grubhub-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-tax-4': 'Taxe de livraison GrubHub 4',
    'delivery-grubhub-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes GrubHub. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-grubhub-1-ad-tax-4': 'Taxe de livraison GrubHub 1-AD 4',
    'delivery-grubhub-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes GrubHub intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax': 'Taxe de livraison PostMates',
    'delivery-postmates-tax-description': 'Total des taxes de livraison pour les commandes PostMates',
    'delivery-postmates-1-ad-tax': 'Taxe de livraison PostMates 1-AD',
    'delivery-postmates-1-ad-tax-description': 'Total des taxes de livraison pour les commandes PostMates intégrées',
    'delivery-postmates-tax-1': 'Taxe de livraison PostMates 1',
    'delivery-postmates-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-1': 'Taxe de livraison PostMates 1-AD 1',
    'delivery-postmates-1-ad-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax-2': 'Taxe de livraison PostMates 2',
    'delivery-postmates-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-2': 'Taxe de livraison PostMates 1-AD 2',
    'delivery-postmates-1-ad-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax-3': 'Taxe de livraison PostMates 3',
    'delivery-postmates-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-3': 'Taxe de livraison PostMates 1-AD 3',
    'delivery-postmates-1-ad-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-tax-4': 'Taxe de livraison PostMates 4',
    'delivery-postmates-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes PostMates. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'delivery-postmates-1-ad-tax-4': 'Taxe de livraison PostMates 1-AD 4',
    'delivery-postmates-1-ad-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes PostMates intégrées. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-1': 'Taxe sur place mobile 1',
    'mobile-eat-in-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-2': 'Taxe sur place mobile 2',
    'mobile-eat-in-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-3': 'Taxe sur place mobile 3',
    'mobile-eat-in-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-4': 'Taxe sur place mobile 4',
    'mobile-eat-in-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes mobiles consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-eat-in-tax-total': 'Total de la taxe sur place mobile',
    'mobile-eat-in-tax-total-description': 'Taxes sur les commandes mobiles consommées au restaurant',
    'mobile-takeout-tax-1': 'Taxe pour emporter mobile 1',
    'mobile-takeout-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes mobiles emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-2': 'Taxe pour emporter mobile 2',
    'mobile-takeout-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes mobiles emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-3': 'Taxe pour emporter mobile 3',
    'mobile-takeout-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes mobiles emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-4': 'Taxe pour emporter mobile 4',
    'mobile-takeout-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes mobiles emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'mobile-takeout-tax-total': 'Total de la taxe pour emporter mobile',
    'mobile-takeout-tax-total-description': 'Taxes sur les commandes mobiles emportées à l’extérieur du restaurant pour consommation',
    'eat-in-tax-amt': 'Mnt taxe sur place',
    'eat-in-tax-amt-description': 'Total des taxes pour les commandes consommées au restaurant',
    'eat-in-tax-1': 'Taxe sur place 1',
    'eat-in-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'eat-in-tax-2': 'Taxe sur place 2',
    'eat-in-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'eat-in-tax-3': 'Taxe sur place 3',
    'eat-in-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'eat-in-tax-4': 'Taxe sur place 4',
    'eat-in-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes consommées au restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-amt': 'Mnt taxe pour emporter',
    'takeout-tax-amt-description': 'Total des taxes pour les commandes emportées à l’extérieur du restaurant pour consommation',
    'takeout-tax-1': 'Taxe pour emporter 1',
    'takeout-tax-1-description': 'Montant de taxe perçu au titre de la taxe primaire de la chaîne de taxes pour les commandes emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-2': 'Taxe pour emporter 2',
    'takeout-tax-2-description': 'Montant de taxe perçu au titre de la taxe secondaire de la chaîne de taxes pour les commandes emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-3': 'Taxe pour emporter 3',
    'takeout-tax-3-description': 'Montant de taxe perçu au titre de la taxe tertiaire de la chaîne de taxes pour les commandes emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'takeout-tax-4': 'Taxe pour emporter 4',
    'takeout-tax-4-description': 'Montant de taxe perçu au titre de la taxe quaternaire de la chaîne de taxes pour les commandes emportées à l’extérieur du restaurant. Tous les restaurants utilisent la taxe 1; certains utilisent aussi les taxes 2, 3 et 4',
    'fee-1-amount': 'Montant des frais 1',
    'fee-1-amount-description': 'Le PDV permet de percevoir des frais (distincts des taxes et habituellement non taxés)',
    'fee-2-amount': 'Montant des frais 2',
    'fee-2-amount-description': 'Le PDV permet de percevoir des frais (distincts des taxes et habituellement non taxés)',
    'deposit-1-amount': 'Montant de la consigne 1',
    'deposit-1-amount-description': 'Montant de toute consigne 1 facturée au client pour les bouteilles',
    'deposit-2-amount': 'Montant de la consigne 2',
    'deposit-2-amount-description': 'Montant de toute consigne 2 facturée au client pour les bouteilles',
    'deposit-amt-bottles-description': 'Montant total des consignes facturées au client pour les bouteilles',

    // Register Audit
    'register-audit': 'Audit des caisses',
    'this-report-aggregates-footnote': 'Ce rapport regroupe les valeurs par tiroir-caisse. Dans les restaurants ouverts 24 h sur 24, un tiroir peut chevaucher la fin de la journée d’exploitation et les valeurs peuvent ne pas correspondre à celles de la feuille de caisse',
    'by-location': 'Par emplacement',
    'sum-all-locations': 'Cumul de tous les emplacements',
    'by-employee': 'Par employé',
    'employee-drawer': 'Tiroir de l’employé',
    'cashier': 'Caissier',
    'cashier-name': 'Nom du caissier',
    'manager': 'Gérant',
    'manager-name': 'Nom du gérant',
    'preparer': 'Préparateur',
    'preparer-name': 'Nom du préparateur',
    'cash-out-time': 'Heure de fermeture du tiroir',
    'time-the-cash-register-drawer-was-closed': 'Heure à laquelle le tiroir-caisse a été fermé',
    'emp-name': 'Nom de l’employé',
    'employee-name': 'Nom de l’employé',
    'Register': 'Caisse',
    'By-Location': 'Par emplacement',
    'By-Employee': 'Par employé',
    'Employee': 'Employé',

    // Gift Card Summary
    'gift-card-summary': 'Sommaire des cartes-cadeaux',
    'net-qty': 'Qté nette',
    'sold-qty-redeemed-qty': 'Qté vendue - Qté échangée',
    'net-amt': 'Mnt net',
    'sold-dollars-redeemed-dollars': 'Dollars vendus - Dollars échangés',
    'sold-qty': 'Qté vendue',
    'the-quantity-of-gift-cards-activated-or-reloaded': 'Nombre de cartes-cadeaux activées ou rechargées',
    'sold-dollars': 'Dollars vendus',
    'the-dollar-amount-of-gift-cards-activated-or-reloaded': 'Montant en dollars des cartes-cadeaux activées ou rechargées',
    'sold-average-check': 'Facture moyenne vendue',
    'sold-dollars-sold-qty': 'Dollars vendus / Qté vendue',
    'redeemed-qty': 'Qté échangée',
    'the-quantity-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'Nombre de cartes-cadeaux utilisées pour payer une commande en tout ou en partie',
    'redeemed-dollars': 'Dollars échangés',
    'the-dollar-amount-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'Montant en dollars des cartes-cadeaux utilisées pour payer une commande en tout ou en partie',
    'redeemed-average-check': 'Facture moyenne échangée',
    'redeemed-dollars-redeemed-qty': 'Dollars échangés / Qté échangée',
    'gift-card-summary-catalog-grid-name': 'Sommaire des cartes-cadeaux',

    // Other Receipts
    'other-receipts-grid-name': 'Autres recettes',
    'other-receipts-grid-footer': 'Si la plage de dates comprend une date avec un RBD, ce rapport pourrait ne pas correspondre à la feuille de caisse.',
    'other-receipts-today-grid-name': 'Autres recettes - Aujourd’hui',
    'other-receipts-detail-grid-name': 'Détail des autres recettes',

    // Billable Sales / Safe Counts
    'billable-sales-grid-name': 'Ventes facturables',
    'safe-counts-grid-name': 'Décomptes du coffre',

    // ByMenuItemSelector
    'by-menu-item': 'Par article du menu',

    // Cash Statistics (standard)
    'cash-statistics': 'Statistiques de caisse',
    'by-date': 'Par date',
    'cash-statistics-analysis': 'Analyse des statistiques de caisse',

    // Legacy camelCase keys (kept for backward compatibility with existing code)
    'drawer': 'Tiroir-caisse',
    'safeCount': 'Décompte du coffre',
    'cashOverShort': 'Excédent/manque de caisse',
    'cashOverShortDescription': 'L’excédent/manque de caisse correspond au dépôt prévu moins le comptant prévu.',
    'projectedDeposit': 'Dépôt prévu',
    'foreignCurrencyDeposit': 'Dépôt en devises étrangères',
    'depositCrimeLoss': 'Perte de dépôt liée à un vol',
    'pettyCashReimbursement': 'Remboursement de la petite caisse',
    'actualDeposit': 'Dépôt réel',
    'foreignCurrency': 'Devises étrangères',
    'expectedCash': 'Comptant prévu',
    'posOverrings': 'Surenregistrements PDV',
    'cashRefund': 'Remboursement comptant',
    'giftCertificatesRedeemed': 'Chèques-cadeaux échangés',
    'giftCardsRedeemed': 'Cartes-cadeaux échangées',
    'billableSales': 'Ventes facturables',
    'delivery3rdPartyGross': 'Livraison par un tiers - brut',
    'cashlessSales': 'Ventes sans comptant',
    'mobileCashless': 'Sans comptant mobile',
    'inStoreCashless': 'Sans comptant en restaurant',
    'denotesReconstructedMetric': '# indique un indicateur reconstitué',

    // CashsheetReceipt (MT redesign)
    'cs-breakdown': 'Répartition',
    'cs-net-sales-by-channel': 'Ventes nettes par canal',
    'cs-taxable-sales': 'Ventes taxables',
    'cs-delivery-3rd-party': 'Tiers',
    'cs-delivery-internal': 'Interne',
    'cs-transactions': 'Transactions',
    'cs-pct-of-gross': '{pct} du brut',
    'cs-pct-of-net': '{pct} du net',
    'cs-avg-check': 'Facture moyenne {amt}',
    'cs-drawer-reconciliation': 'Rapprochement de caisse',
    'cs-where-the-net-came-from': 'Origine des ventes nettes',
    'cs-error-loading': 'Une erreur est survenue lors du chargement de la feuille de caisse.',
    'cs-hide-zero-rows': 'Masquer les lignes à zéro',
    'cs-vs-ly': 'vs AP {pct}',
    'cs-deposit-short': 'Dépôt manquant',
    'cs-deposit-over': 'Dépôt excédentaire',
    'cs-total-surcharges': 'Total des surcharges',
  },
};
